/*!* Global JS  v13.08.24:01*/
import { tns } from "tiny-slider"
import { getDynamicMenuResponse } from '../opus2/util/getDynamicMenu';
import { getCampaignName, getBrandDetailsFromBrandJson, isOperationActiveNow, isNegative, removeElementEventListeners, manageTNSPaginationDots } from "../opus2/util/share";
import { ScreenType } from "../opus2/location-search-map/models/ScreenType";
import { reportScreenSize } from "../opus2/location-search-map/reportScreenSize";
import { getMessagesData } from "../opus2/util/siteConfig";
import { isTouchDevice } from "../opus2/util/device-detection";
import { attachEventListenerForClaim } from "../opus2/util/coupons-event-handling";
import { getDisplayPhoneNumber, isLocalized } from "../opus2/util/localizationService";
import apiRequest from "../opus2/api/apiRequest";
import { fetchLocalTokenInfo } from "../opus2/helperModules/localizedToken";
import {hoverintent} from "../opus2/util/hoverintent";
import { cachedAPIWrapper } from "../opus2/apiCaching/apiWrapper";
import { apiConfig } from "../opus2/config/apiConfig";
import { apiCaching } from "../opus2/config/cachingConfig";
import { startLoader, stopLoader } from "../opus2/util/loader";
import { getPageSettings } from "../opus2/util/pageSettings";
import { getSureStartProgramData } from "../opus2/util/add-Page-Type-DataLayer";
import { isValidCAPostalCode } from "../opus2/nbly-brand/helper_functions";
import { BrandResult } from "../opus2/search-result";
// Extend the Window and globalThis interfaces to include Flowbite
declare global {
    interface Window {
        initAccordions?: () => void;
    }
    interface GlobalThis {
        initAccordions?: () => void;
    }
}
export class StickyHeader {
    private firstHead: HTMLElement | null;
    private headerH: number;
    public dynamicMenuType: string;
    public menuCloseTimeout: Map<number, NodeJS.Timeout> = new Map();
    private readonly headerAlert: HTMLElement | null;
    private static instance: StickyHeader | null = null;
    private headerAlertObserver: MutationObserver | null = null;

    constructor(brandData: any) {
        this.firstHead = document.querySelector(".first-head");
        const secondHead: HTMLElement | null = document.querySelector(".second-head");
        this.headerH = secondHead?.offsetHeight ?? 0;
        this.dynamicMenuType = '';
        this.headerAlert = document.getElementById('header-alert');
        const placeholder = document.createElement('div');
        if (placeholder) {
            placeholder.id = 'sticky-placeholder';
        }
        if (placeholder?.style) {
            placeholder.style.width = '100%';
            placeholder.style.display = 'none'; // hidden by default
        }
        secondHead?.parentNode?.insertBefore?.(placeholder, secondHead);

        // Optional: observe resize to adjust placeholder height if header changes
        window.addEventListener('resize', () => {
            if (placeholder?.style?.display === 'block') {
                placeholder.style.height = this.getSecondHeadHeight() + 'px';
            }
        });

        this.stickyHeader(brandData);

        //FOR SITEMAP TARGET LINK
        const allElements = document.querySelectorAll('.link-target');
        allElements?.forEach((element: any) => {
            element.style.scrollMarginTop = this.headerH - 30 + "px";
        });

        setTimeout(() => {
            this.megaMenu.call(this);
        }, 1000);
        this.readDynamicMenu();

        getCampaignName();
    }
    static getInstance(brandData: any): StickyHeader {
        StickyHeader.instance ??= new StickyHeader(brandData);
        return StickyHeader.instance;
    }
    static async init() {
        try {

            const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
            const brandData = await getBrandDetailsFromBrandJson(conceptCode);
            const secondHead: HTMLElement | null = document.querySelector(".second-head");
            const pageType = (document.getElementById('pageType') as HTMLInputElement)?.value;

            if ((pageType !== 'Opus 2 Lead Flow Template') && (pageType !== 'Opus 2 Onverity-IMS Lead Flow') && (pageType !== 'Opus 2 HMS Lead Flow Template') && (pageType !== 'Opus 2 MLY Lead Flow Template') && (pageType !== 'Opus 2 Agnostic Lead Flow Template')) {
                if (secondHead) {
                    await this.checkToToggleLogoAndLocationFromStickyHeader(secondHead);
                }
            }
         StickyHeader.getInstance(brandData || {});
        } catch (error) {
            console.error("Error initializing StickyHeader:", error);
            StickyHeader.getInstance({});
        }
    }
    getSecondHeadHeight() {
        const secondHead: HTMLElement | null = document.querySelector(".second-head");
        if(secondHead) return secondHead.offsetHeight;
        return 0;
    }

    getHeaderHeight() {
        if (!this.headerAlert?.classList.contains('hidden')) {
            return (this.headerAlert?.offsetHeight ?? 0) + (this.firstHead?.offsetHeight ?? 0);
        }
        return this.firstHead?.offsetHeight ?? 0;
    }

    //Sticky Header
    public stickyHeader(brandData: any) {
        const secondHead: HTMLElement | null = document.querySelector(".second-head");
        let theHeightofMenuNew: any = 0;
        let theHeightofMenu: any = 0;
        let findLocalMobile = document.querySelector(".find-local-mobile") as HTMLElement;
        let mobileMenuLogo = document.querySelector(".second-head .mobile-menu-logo") as HTMLImageElement;
        let headerCtaMobile = document.querySelector(".second-head .header-cta-mobile") as HTMLElement;
        // Define placeholder so it is accessible in inner functions
        const placeholder = document.getElementById('sticky-placeholder') as HTMLElement;
        if (mobileMenuLogo) {
            theHeightofMenu = mobileMenuLogo.offsetHeight;
        }
        if (mobileMenuLogo && headerCtaMobile && findLocalMobile) {
            theHeightofMenuNew = mobileMenuLogo.offsetHeight + headerCtaMobile.offsetHeight + findLocalMobile.offsetHeight;
        }
        const headerElement = document.querySelector(".second-head") as HTMLElement;
        const faqULElements = document.querySelectorAll<HTMLElement>(".accordion-icon-list");
        faqULElements?.forEach((faqElement) => {
            faqElement?.addEventListener('click', (event: any) => {
                let headerOffset = headerElement?.offsetHeight;
                const faqBtn = (event.target as HTMLElement).closest(".card-list") as HTMLElement;
                if (event.target && faqBtn) {
                    const faqFormPosition = faqBtn.getBoundingClientRect().top + window.scrollY;
                    const offsetPosition = faqFormPosition - headerOffset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }
            });
        });

        const bookYourInspection = document.querySelector<HTMLElement>(".secondary-btn");
        if (bookYourInspection && typeof bookYourInspection.getAttribute === 'function') {
            if (bookYourInspection?.getAttribute('href')?.includes("#short-form-req-name")) {
                bookYourInspection?.addEventListener('click', (event) => {
                    event.preventDefault();
                    let headerOffset = headerElement?.offsetHeight;
                    const shortForm = document.querySelector(".short-form-component");
                    if (shortForm) {
                    const shortFormPosition = shortForm.getBoundingClientRect().top + window.scrollY;
                    const offsetPosition = shortFormPosition - headerOffset;
                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }
            });
        }
        }
        let lastScrollTop = 0;
        let ticking = false;
        const self = this;

        // Function to apply sticky state
        const applySticky = () => {
            if (!placeholder?.style?.display || placeholder?.style?.display === 'none') {
                if (placeholder?.style) {
                    placeholder.style.height = this.getSecondHeadHeight() + 'px';
                    placeholder.style.display = 'block';
                }
            }
            if (self.headerAlert?.classList.contains('fixed-alert')) {
                self.headerAlert.style.position = 'fixed';
                if(secondHead){
                    secondHead.style.marginTop = self.headerAlert.offsetHeight + 'px';
                }
            }
            self.firstHead?.classList?.add("hidden");
            (secondHead as HTMLElement)?.classList?.remove("relative");
            secondHead?.classList?.add("fixed", "top-0");
        };
        // Function to remove sticky state
        const removeSticky = () => {
            if (placeholder?.style?.display === 'block') {
                placeholder.style.height = '0px';
                placeholder.style.display = 'none';
            }
            if (self.headerAlert?.classList.contains('fixed-alert')) {
                self.headerAlert.style.position = 'relative';
                if(secondHead){
                    secondHead.style.marginTop = '0';
                }
            }
            self.firstHead?.classList?.remove("hidden");
            secondHead?.classList?.remove("fixed", "top-0");
            secondHead?.classList?.add("relative");
        };

        if (self.headerAlert) {
            const observer = new MutationObserver(() => {
                try {
                    if (self.headerAlert?.classList.contains('hidden')) {
                        if (secondHead) {
                            secondHead.style.marginTop = '0';
                        }
                    }
                } catch (error) {
                    console.error("Error in MutationObserver callback:", error);
                }
            });
            observer.observe(self.headerAlert, {
                attributes: true,
                attributeFilter: ['class'],
                childList: false, // Only observe changes to the attributes
                subtree: false
            });
            // Store the observer for later disconnection
            self.headerAlertObserver = observer;
        }
        
        let lastHeight = 0;
        const handleCompressHeader = () => {
            const mainHeader = document.querySelector('.main-header');
            if (!mainHeader?.classList?.contains('compressed-header')) return;
            
            const stickyPlaceholder = document.getElementById('sticky-placeholder');
            if (!stickyPlaceholder || !secondHead) return;
            
            // Use requestAnimationFrame to prevent flashy update
            requestAnimationFrame(() => {
                const newHeight = secondHead.offsetHeight;
                if (newHeight !== lastHeight) {
                    lastHeight = newHeight;
                    stickyPlaceholder.style.height = `${newHeight}px`;
                }
            });
        };

        window.addEventListener("scroll", () => {

            const currentScrollTop = window.scrollY;
            let stickyTrigger = secondHead ? secondHead.offsetTop : 0;
            let pageYOffset = window.pageYOffset;
            let width = window.innerWidth;

            if (!ticking) {
                window.requestAnimationFrame(() => {
                    if (window.innerWidth < 1024) {
                        if (!isNegative(lastScrollTop) && currentScrollTop > lastScrollTop) {  // Scrolling Down
                            // Hide sticky header when scrolling down
                            if (secondHead?.classList?.contains("sticky-head")) {
                                secondHead?.classList?.add("hidden");
                            }
                        } else if (currentScrollTop < lastScrollTop || (isNegative(lastScrollTop))) {  // Scrolling Up
                            // Show sticky header when scrolling up
                            if (secondHead?.classList?.contains("sticky-head")) {
                                secondHead?.classList?.remove("hidden");
                            }
                        }
                    }
                    lastScrollTop = window.scrollY;
                    ticking = false;
                });
                ticking = true;
            }

            // Handle compressed-header functionality on scroll
            handleCompressHeader();
            if (width < 1024) {
                // Mobile conditions
                if (brandData?.disable_sticky_header_mobile) {
                    // If sticky header is disabled for the brand, always remove it in mobile
                    removeSticky();
                }
                //If the flag - disable_findmylocations is true, the mobile logo and header-cta-mobile will be sticky and find-local-mobile will be scrolled out in mobile view
                else if (brandData?.disable_findmylocations) {
                    if (pageYOffset > theHeightofMenu) {
                        applySticky();
                        if (findLocalMobile) {
                            findLocalMobile.style.display = 'none';
                        }
                    }
                    else {
                        removeSticky();
                        if (findLocalMobile) {
                            findLocalMobile.style.display = 'flex';
                        }
                    }

                }
                else if (secondHead?.classList?.contains("sticky-head") && !secondHead?.classList?.contains("hide-find-local")) {
                    // Case: sticky-head without hide-find-local              
                    if (pageYOffset > theHeightofMenu) applySticky(); else removeSticky();
                }
                else if (secondHead?.classList?.contains("hide-find-local") && secondHead?.classList?.contains("sticky-head")) {
                    if (pageYOffset > theHeightofMenuNew) {
                        applySticky();
                        if (findLocalMobile?.style) {
                            findLocalMobile.style.display = "none";
                        }
                    } else {
                        removeSticky();
                        if (findLocalMobile?.style) {
                            findLocalMobile.style.display = "flex";
                        }
                    }
                }
                // Case: default mobile without special classes
                else if (!secondHead?.classList?.contains("hide-find-local") && !secondHead?.classList?.contains("sticky-head")) {
                    if (pageYOffset > stickyTrigger) applySticky(); else removeSticky();
                }
            }

            // Desktop condition
            else if (width > 1024) { // Desktop
                if (brandData?.disable_sticky_header || pageYOffset <= this.getHeaderHeight()) {
                    // Always remove sticky
                    removeSticky();
                } else {
                    // Sticky header enabled apply or remove based on scroll               
                    applySticky();
                }
            }
            
        });
    }

    public disconnectObserver() {
        try {
            if (this.headerAlertObserver) {
                this.headerAlertObserver.disconnect();
                this.headerAlertObserver = null;
            }
        } catch (error) {
            console.error("Error disconnecting header alert observer:", error);
        }
    }
    static destroy(){
        if (StickyHeader.instance) {
            StickyHeader.instance.disconnectObserver();
        }
    }
    async readDynamicMenu() {
        try {
            const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
            const brandData = await getBrandDetailsFromBrandJson(conceptCode);

            if(!brandData?.display_icon_menu){   
                let response = await getDynamicMenuResponse();
                this.dynamicMenuType = response?.dynamicMenuType;
                this.dynamicMenuV2();
                dynamicMenuV4(response);
                this.initializeSubmegaTabs();
            }else {
                const response = { dynamicMenuType: 'dynamic menu icons' };
                dynamicMenuV4(response);
            }
        }
        catch (e) {
            console.warn("Error Fetching dynamic menu")
        }
        await addLocalizationHeaderMenuLocal();
    }
    public initializeSubmegaTabs(): void {
        const menuContainer = document.querySelector(".dynamic-service-menu")?.closest("ul");

        if (!menuContainer) {
            console.error("No parent <ul> found for '.dynamic-service-menu'.");
            return;
        }

        menuContainer.addEventListener("click", function (event: Event) {
            const targetElement = (event.target as HTMLElement).closest<HTMLButtonElement>(".submega-tab-button");

            if (!targetElement) return;

            const targetId = targetElement.getAttribute("data-tabs-target");

            if (!targetId) {
                console.error("No target ID found for button:", targetElement);
                return;
            }

            const targetContent = document.querySelector<HTMLElement>(targetId);

            if (!targetContent) {
                console.error("No target element found for selector:", targetId);
                return;
            }

            const tabContentContainer = document.querySelector(".submega-tab-content");

            if (!tabContentContainer) {
                console.error("No '.submega-tab-content' container found.");
                return;
            }

            // Hide all tab content
            document.querySelectorAll<HTMLElement>(".submega-tab-content > div").forEach(content => {

                content.classList.add("hidden");
            });

            // Reset all buttons' aria-selected
            document.querySelectorAll<HTMLButtonElement>(".submega-tab-button").forEach(btn => {
                btn.setAttribute("aria-selected", "false");
            });

            // Show selected tab content and update aria-selected
            targetContent.classList.remove("hidden");
            targetElement.setAttribute("aria-selected", "true");
        });
    }

    megaMenu() {
        // MEGA MENU JS STARTS HERE
        const firstMenu = document.querySelector<HTMLElement>(".mega-menu");
        const secondMenu = document.querySelector<HTMLElement>(".sub-menu");
        const theMenuButton: any = document.querySelector<HTMLElement>(".mobile-sidebar-drawer");
        const showMenu = document.querySelectorAll<HTMLElement>(".expand-menu-js");

        const mainMenu = document.querySelectorAll<HTMLElement>('.nav-link');

        if (window.matchMedia("(max-width: 1023px)").matches) {
            theMenuButton?.setAttribute("data-drawer-target", "sidebar");
            theMenuButton?.setAttribute("data-drawer-toggle", "sidebar");
            theMenuButton?.setAttribute("data-drawer-backdrop", "false");
        }

        mainMenu?.forEach(main => {
            const screenType = reportScreenSize();
            if (screenType !== ScreenType.Desktop) {
                main.addEventListener('click', function handleClick(event) {
                    let id: any = this.getAttribute('data-nested-value');
                    let idWrap = document.getElementById(id);
                    idWrap?.classList.add('show-menu');
                    idWrap?.classList.remove('hide-menu');
                });
            }
        });

        const mobileMenuLinks = document.querySelectorAll<HTMLButtonElement>('button.nav-link-mobile');
        mobileMenuLinks.forEach(link => {
            link.addEventListener('click', function handleClick() {
                const target = this.dataset.nestedValue;
                if (target) {
                    document.getElementById(target)?.classList.add('active');
                }
                this.setAttribute('aria-expanded', 'true');
            });
        });

        const backBtn = document.querySelectorAll<HTMLElement>('.back-btn');
        backBtn?.forEach(back => {
            back.addEventListener('click', function handleClick(event) {
                let nameBack: any = this.getAttribute('data-back');
                let idWrap = document.getElementById(nameBack);
                idWrap?.classList.remove('show-menu');
                idWrap?.classList.add('hide-Submenu');
            });
        });

        const backTabBtn = document.querySelectorAll<HTMLElement>('.back-tab-btn');
        backTabBtn?.forEach(back => {
            back.addEventListener('click', function handleClick(event) {
                back.closest(".mega-menu")?.querySelector(".tab-sibling")?.classList.remove('hide-menu');
                let nameBack: any = this.getAttribute('data-back');
                let idWrap = document.getElementById(nameBack);
                idWrap?.classList.remove('show-menu');
                idWrap?.classList.add('hidden');
            });
        });

        const closeNav = document.querySelector<HTMLElement>(".sidenav-close");
        closeNav?.addEventListener('click', closeAllMenu);
        let allFirstMenu = document.querySelectorAll<HTMLElement>(".mega-menu");
        let allSecondMenu = document.querySelectorAll<HTMLElement>(".sub-menu");

        function closeAllMenu() {
            allFirstMenu.forEach((element) => {
                element?.classList.remove('show-menu');
            });
            allSecondMenu.forEach((element) => {
                element?.classList.add('hide-Submenu');
            });
            document.querySelector<HTMLElement>(".tab-sibling")?.classList.remove('hide-menu');

            // Remove dynamic 4 menu
            const dynamicMenuWrap = document.querySelector(".dynamic-menu-wrap");
            if (dynamicMenuWrap) {
                dynamicMenuWrap.classList.add('hide-menu');
                dynamicMenuWrap.classList.remove('show-menu');
            }

            const subMenus = document.querySelectorAll('.new-submenu-inner-warp > div');
            if (subMenus.length > 0) {
                subMenus.forEach((subMenu: Element) => {
                    subMenu.classList.add('hide-menu');
                    subMenu.classList.remove('show-menu');
                });
            }
        }

        const slideBlock = document.querySelector<HTMLElement>(".slide-block");
        const brandHeader = document.querySelector<HTMLElement>(".main-nav-warpper");
        const slideBlockH: any = slideBlock?.offsetHeight;
        const brandHeaderH = brandHeader?.offsetHeight;
        const firstMenuTop = document.querySelectorAll<HTMLElement>(".mega-menu");
        const firstSubMenuTop = document.querySelectorAll<HTMLElement>(".sub-menu");

        const mql = window.matchMedia("(max-width: 1023px)");

        if (mql.matches) {
            firstMenuTop.forEach((element: any) => {
                element.style.top = slideBlockH + 16 + "px";
            });
            firstSubMenuTop.forEach((element: any) => {
                element.style.top = "0";
            });
        }

        // RESET SUBMEGAMENU ON MOUSE LEAVE
        const subMegaMenu: any = document.getElementsByClassName('submega-inner-warp');
        if (subMegaMenu.length === 0) return;
        let self = this;
        if (window.matchMedia("(min-width:1024px)").matches) {
            for (let i = 0; i < subMegaMenu.length; i++) {
                subMegaMenu[i].onmouseleave = function () {
                    const tabSiblings = document.getElementsByClassName("mega-inner-warp tab-sibling");
                    if (!tabSiblings) return;
                    if (!self.menuCloseTimeout.has(i)) {
                        self.menuCloseTimeout.set(i, setTimeout(() => {
                            if (!tabSiblings[i]) return;
                            tabSiblings[i]?.classList.remove('hide-menu');
                            subMegaMenu[i]?.classList.remove('show-menu');
                            subMegaMenu[i]?.classList.add('hide-menu');
                            const hideSubMegaMenu = document.querySelectorAll('.submega-tab-content div[role="tabpanel"]');
                            hideSubMegaMenu.forEach(item => {
                                item.classList.add('hidden');
                            })
                            const resetMenuBtn = document.querySelectorAll('.submega-tab li[role="presentation"] button');
                            resetMenuBtn.forEach(item => {
                                item.setAttribute("aria-selected", "false");
                            })
                        }, 300));
                    }
                }
                subMegaMenu[i].onmouseenter = function () {
                    if (self.menuCloseTimeout.get(i)) {
                        clearTimeout(self.menuCloseTimeout.get(i));
                        self.menuCloseTimeout.delete(i);
                    }
                }
            }

            // Also add mouseenter to ads-wrapper to prevent closing
            const adsWrapper = document.querySelectorAll('.ads-wrapper');
            if (adsWrapper.length === 0) return;
            adsWrapper.forEach((wrapper) => {
                (wrapper as HTMLElement).onmouseenter = function () {
                    if (self.menuCloseTimeout.size > 0) {
                        self.menuCloseTimeout.forEach((timeoutId) => {
                            clearTimeout(timeoutId);
                        });
                        self.menuCloseTimeout.clear();
                    }
                }
            });
        }

    }

    static async checkToToggleLogoAndLocationFromStickyHeader(menuDOM: HTMLElement) {
        const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
        const brandData = await getBrandDetailsFromBrandJson(conceptCode);
        if (brandData) {

            //remove logo from sticky header
            if (brandData.disable_stickyheader_logo) {
                menuDOM.classList.add("sticky-head")
            }
            else {
                menuDOM.classList.remove("sticky-head")
            }

            //remove find my location from sticky header
            if (brandData.disable_findmylocations) {
                menuDOM.classList.add("hide-find-local")
            }
            else {
                menuDOM.classList.remove("hide-find-local")
            }
        }
    }

    public dynamicMenuV2() {

        const mainSubMenu = document.querySelectorAll<HTMLElement>('.expand-menu-js');
        this.dynamicMenuType = this.dynamicMenuType?.replace(/\s/g, "")?.toLowerCase();
        const dynamicStr = 'Dynamic Menu V2'.replace(/\s/g, "").toLowerCase();
        if (this.dynamicMenuType == dynamicStr) {
            mainSubMenu?.forEach(main => {
                main.addEventListener('click', function handleClick(event) {
                    try {
                        if (main.closest(".dynamic-service-menu .tab-sibling")) {
                            main.closest(".dynamic-service-menu .tab-sibling")?.classList.add('hide-menu');
                        }

                        let id: any = this.getAttribute('data-nested-value');
                        let tab: any = this.getAttribute('data-active-tab');
                        let idWrap = document.getElementById(id);
                        idWrap?.classList.add('show-menu');
                        idWrap?.classList.remove('hide-menu');

                        let idTab = document.getElementById(tab);
                        idTab?.closest(".submega-tab")?.querySelector(".submega-tab-button")?.setAttribute("aria-selected", "false");
                        idTab?.setAttribute("aria-selected", "true");

                        let openTab = idTab?.getAttribute("data-tabs-target");
                        let tabIdsArray: any = openTab?.split("#");

                        if (tabIdsArray && tabIdsArray.length > 0) {

                            let idTabCont = document.getElementById(tabIdsArray[1]);
                            idTabCont?.closest(".submega-inner-warp")?.querySelector(".submega-tab-content div[role='tabpanel']")?.classList.add('hidden');
                            idTabCont?.classList.remove('hidden');

                        }
                    } catch (error) {
                        console.error("An error occurred in the click event:", error);
                    }
                });
            });
        }
    }

}

class AsideDiv {
    private aside: HTMLElement | null;
    private secondHead: HTMLElement | null;
    private headerH: number;

    constructor() {
        this.secondHead = document.querySelector(".second-head");
        this.aside = document.querySelector(".blog-aside");
        this.headerH = this.secondHead?.offsetHeight || 0;
        if (this.aside) {
            this.aside.style.top = this.headerH - 64 + "px";;
        }

        //FOR SITEMAP TARGET LINK
        const allElements = document.querySelectorAll('.link-target');
        allElements?.forEach((element: any) => {
            element.style.scrollMarginTop = this.headerH - 30 + "px";
        });
    }
}

export class TinySlider {
    private offerSlider: HTMLElement | null;
    private offerWrapper: HTMLElement | null;

    constructor() {
        this.offerSlider = document.querySelector(".offers-slider");
        this.offerWrapper = document.querySelector(".offers-block-wrapper");
        // .offers-block-section .offers-block-list .offers-block-item

        if (this.offerSlider) {
            const offersCount = this.offerSlider.getElementsByTagName("li").length;
            let itemsToShow = 4;
            if (offersCount < itemsToShow) {
                itemsToShow = offersCount;
            }
            const slider = tns({
                container: this.offerSlider,
                items: 1,
                loop: false,
                gutter: 20,
                controlsText: ['<svg aria-hidden="true" class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-left-white"></use></svg>', '<svg aria-hidden="true"  class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-right-white"></use></svg>'],
                responsive: {
                    1024: { items: 2 },
                    1200: { items: 3 },
                    1300: { items: itemsToShow }
                }
            });

            let firstMenuTop = document.querySelectorAll(".mega-menu");
            let slideBlock: any = document.querySelector(".slide-block");
            let slideBlockH = slideBlock?.offsetHeight;
            let mql = window.matchMedia("(max-width: 768px)")

        }
    }
}

export class CustomerReviewSlider {
    private reviewSlider: HTMLElement | null;
    private reviewSlider1: HTMLElement | null;
    private reviewWrapper: HTMLElement | null;

    constructor() {
        this.reviewSlider = document.querySelector(".review-slider");
        this.reviewSlider1 = document.querySelector(".review-slider1");
        this.reviewWrapper = document.querySelector(".reviews-list-wrapper");

        let itemsCount = this.reviewSlider?.querySelectorAll(".reviews-item").length ?? 0;
        if (itemsCount < 4 && window.innerWidth >= 1024) {
            // Disable the slider by removing the class and emptying the container
            this.reviewSlider?.classList?.remove("review-slider");
        }
        else if (itemsCount == 1 && this.reviewWrapper) {
                this.reviewWrapper.style.paddingBottom = "0";
        } else {

            const setupReviewSlider = (sliderContainer: HTMLElement) => {
                const slider = tns({
                    container: sliderContainer,
                    items: 1,
                    loop: false,
                    controlsText: ['<svg aria-hidden="true" class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-left-white"></use></svg>', '<svg aria-hidden="true"  class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-right-white"></use></svg>'],
                    responsive: {
                        1024: { items: 2 },
                        1200: { items: 3 }
                    }
                });

            };


            if (this.reviewSlider) {
                setupReviewSlider(this.reviewSlider);

                let firstMenuTop = document.querySelectorAll(".mega-menu");
                let slideBlock: any = document.querySelector(".slide-block");
                let slideBlockH = slideBlock?.offsetHeight;
                let mql = window.matchMedia("(max-width: 768px)")

            }

            if (this.reviewSlider1) {
                setupReviewSlider(this.reviewSlider1);
                let firstMenuTop = document.querySelectorAll(".mega-menu");
                let slideBlock: any = document.querySelector(".slide-block");
                let slideBlockH = slideBlock?.offsetHeight;
                let mql = window.matchMedia("(max-width: 768px)")

            }
        }
         if (this.reviewSlider) {
                const MAX_CHARACTERS = 200;
                const reviewElements = document.querySelectorAll('.reviews-list-wrapper .reviews-item .review');
                if (!reviewElements || reviewElements?.length === 0) return;
                reviewElements?.forEach((reviewEl) => {
                    if (!(reviewEl instanceof HTMLElement)) return;
                    const originalText = reviewEl?.textContent?.trim() || "";
                    // Apply inline-block directly to <p class="review">
                    reviewEl.style.display = 'inline-block';
                    if (originalText.length <= MAX_CHARACTERS) { return;}
                        const shortText = originalText?.slice(0, MAX_CHARACTERS) + '...';
                        const fullText = originalText;
                        // Create container for truncated and full text
                        const shortSpan = document.createElement('span');
                        shortSpan.className = 'short-text';
                        shortSpan.textContent = shortText;

                        const fullSpan = document.createElement('span');
                        fullSpan.className = 'full-text';
                        fullSpan.textContent = fullText;
                        fullSpan.style.display = 'none';

                        // Create the toggle link
                        const toggleLink = document.createElement('button');
                        toggleLink.className = 'read-btn';
                        toggleLink.textContent = ' Read More';
                        toggleLink.style.cursor = 'pointer';
                        toggleLink.style.textDecoration= 'underline';
                        toggleLink.style.fontStyle = 'normal';

                        // Clear original content and append new elements
                        reviewEl.textContent = '';
                        reviewEl.appendChild(shortSpan);
                        reviewEl.appendChild(fullSpan);
                        reviewEl.appendChild(toggleLink);

                        // Add toggle event
                        toggleLink.addEventListener('click', () => {
                            const isCollapsed = shortSpan.style.display !== 'none';
                            shortSpan.style.display = isCollapsed ? 'none' : 'inline';
                            fullSpan.style.display = isCollapsed ? 'inline' : 'none';
                            toggleLink.textContent = isCollapsed ? ' Read Less' : ' Read More';
                        });
                });
        }
    }
}

// Since its a body component, needs to support multiple gallery sections on the same page
export class PhotoGallerySlider {
    private readonly slideIndexMap = new Map<HTMLElement, number>();

    constructor() {
        const sections = document.querySelectorAll('.photo-gallery-section.content_manual');

        sections?.forEach(sectionEl => {
            const gallerySlider = sectionEl?.querySelector(".gallery-slider") as HTMLElement;
            const modal = sectionEl?.querySelector(".gallery-modal") as HTMLElement;
            if (!modal) return;
            const slides = modal?.getElementsByClassName("pop-up-slider") || [];

            const prevBtn = removeElementEventListeners(modal?.querySelector(".prev")) as HTMLButtonElement;
            const nextBtn = removeElementEventListeners(modal?.querySelector(".next")) as HTMLButtonElement;
            const closeModalBtn = removeElementEventListeners(modal?.querySelector(".close"));
            if (!prevBtn || !nextBtn || !closeModalBtn) return;
            const section = sectionEl as HTMLElement;
            this.slideIndexMap.set(section, 1);

            const openModal = () => {
                if (modal) modal.style.display = "flex";
            };

            closeModalBtn?.addEventListener("click", () => {
                if (modal) modal.style.display = "none";
            });

            const galleryList = section.querySelector('.gallery-wrapper .photo-gallery-list') as HTMLUListElement;
            galleryList?.addEventListener('click', (event) => {
                event.stopImmediatePropagation();
                const img = event.target as HTMLElement;
                if (img instanceof HTMLImageElement) {
                    const index = Array.from(galleryList.querySelectorAll('img')).indexOf(img);
                    this.setSlideIndex(section, index + 1);
                    openModal();
                    this.showSlides(section, slides, index + 1);
                    this.updateNavButtons(section, slides, prevBtn, nextBtn);
                }
            });

            prevBtn?.addEventListener("click", () => {
                this.plusSlides(section, -1, slides, prevBtn, nextBtn);
            });

            nextBtn?.addEventListener("click", () => {
                this.plusSlides(section, 1, slides, prevBtn, nextBtn);
            });

            // Initialize Tiny Slider
            if (gallerySlider) {
                tns({
                    container: gallerySlider,
                    items: 1,
                    loop: false,
                    slideBy: 'page',
                    nav: true,
                    navPosition: "bottom",
                    controlsText: [
                        '<svg aria-hidden="true" class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-left-white"></use></svg>',
                        '<svg aria-hidden="true" class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-right-white"></use></svg>'
                    ],
                    responsive: {
                        1024: { items: 2 },
                        1200: { items: 3 }
                    }
                });
            }
        });
    }

    private setSlideIndex(section: HTMLElement, index: number) {
        this.slideIndexMap.set(section, index);
    }

    private getSlideIndex(section: HTMLElement): number {
        return this.slideIndexMap.get(section) ?? 1;
    }

    private plusSlides(
        section: HTMLElement,
        n: number,
        slides: HTMLCollectionOf<Element>,
        prevBtn: HTMLButtonElement,
        nextBtn: HTMLButtonElement
    ) {
        let index = this.getSlideIndex(section) + n;

        if (index < 1) index = 1;
        if (index > slides.length) index = slides.length;

        this.setSlideIndex(section, index);
        this.showSlides(section, slides, index);
        this.updateNavButtons(section, slides, prevBtn, nextBtn);
    }

    private showSlides(section: HTMLElement, slides: HTMLCollectionOf<Element>, n: number) {
        for (const element of slides) {
            (element as HTMLElement).style.display = "none";
        }
        const slideToShow = slides[n - 1] as HTMLElement;
        if (slideToShow) slideToShow.style.display = "flex";
    }

    private updateNavButtons(
        section: HTMLElement,
        slides: HTMLCollectionOf<Element>,
        prevBtn: HTMLButtonElement,
        nextBtn: HTMLButtonElement
    ) {
        const index = this.getSlideIndex(section);
        prevBtn.disabled = index === 1;
        nextBtn.disabled = index === slides.length;
    }
}
//END of Photo gallery changes //

export class ChargerServiceSlider {
    private stepsSlider: HTMLElement | null;
    private stepsWrapper: HTMLElement | null;

    constructor() {
        this.stepsSlider = document.querySelector(".steps-slider");
        this.stepsWrapper = document.querySelector(".steps-img-wrapper");

        const setupSeviceSlider = (sliderContainer: HTMLElement) => {
            const slider = tns({
                container: sliderContainer,
                items: 1,
                loop: false,
                slideBy: 'page',
                nav: true,
                navPosition: "bottom",
                // controlsPosition: "bottom",
                controlsText: ['<svg aria-hidden="true" class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-left-white"></use></svg>', '<svg aria-hidden="true"  class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-right-white"></use></svg>'],
                responsive: {
                    1024: {
                        items: 1,
                    }
                }
            });

            const stepsSliderlist = sliderContainer.getElementsByTagName("li").length;

            const progress = document.querySelectorAll(".card-step");
            const cardSelector = document.querySelector('.card-steps-wrapper') as HTMLElement;
            const prevStep = document.querySelector('.service-steps button[data-controls="prev"]');
            const nextStep = document.querySelector('.service-steps button[data-controls="next"]');
            let steps = 0;
            prevStep?.addEventListener('click', () => {
                if (steps > 0) {
                    steps--;
                    progress.forEach((progressStep, idx) => {
                        if (idx === steps) {
                            progressStep.classList.add("active-step");
                        } else {
                            progressStep.classList.remove("active-step");
                        }
                    });
                }
                if (window.innerWidth < 1024) {
                    cardSelector?.scrollBy(-322, 0);
                }
                else {
                    cardSelector?.scrollBy(-316, 0);
                }
            });
            nextStep?.addEventListener('click', () => {
                if (steps < stepsSliderlist - 1) {
                    steps++;
                    progress.forEach((progressStep, idx) => {
                        if (idx === steps) {
                            progressStep.classList.add("active-step");
                        } else {
                            progressStep.classList.remove("active-step");
                        }
                    });
                }
                if (window.innerWidth < 1024) {
                    cardSelector?.scrollBy(322, 0);
                }
                else {
                    cardSelector?.scrollBy(316, 0);
                }
            });
        };

        if (this.stepsSlider) {
            setupSeviceSlider(this.stepsSlider);
            let firstMenuTop = document.querySelectorAll(".mega-menu");
            let slideBlock: any = document.querySelector(".slide-block");
            let slideBlockH = slideBlock?.offsetHeight;
            let mql = window.matchMedia("(max-width: 768px)")

        }


    }


}

class WindowSlider {
    constructor() {
        this.initWindowSlider();
        if (window.screen && window.screen.width < 1024) {
            this.initWindowWrapSlider();
        }
    }

    // This function for Desktop
    private initWindowSlider() {
        const windowSliderElements = document.querySelectorAll(".window-slider");
        this.initSlider(windowSliderElements);
    }

    // This function for Mobile devices
    private initWindowWrapSlider() {
        const windowWrapElements = document.querySelectorAll(".window-wrap");
        this.initSlider(windowWrapElements);
    }

    private initSlider(nodeList: NodeListOf<Element>) {
        let countSliders = document.getElementsByClassName('window-list-wrapper');
        for (let i = 0; i < countSliders.length; i++) {
            if (nodeList[i]) {
                const slider = tns({
                    container: nodeList[i] as HTMLElement,
                    items: 1,
                    slideBy: "page",
                    loop: false,
                    navPosition: "bottom",
                    controlsText: ['<svg aria-hidden="true" class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-left-white"></use></svg>', '<svg aria-hidden="true"  class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-right-white"></use></svg>'],
                    responsive: {
                        640: {
                            items: 2,
                        },
                        1024: {
                            items: 4
                        }
                    },
                });
            }
        }
    }
}

 class LogoImgSlider {
    private static instance: LogoImgSlider;
    constructor() {
        this.logoImgSliderFunction();
    }

    static getInstance(): LogoImgSlider {
        if (!LogoImgSlider.instance) {
            LogoImgSlider.instance = new LogoImgSlider();
        }
        return LogoImgSlider.instance;
    }

     private logoImgSliderFunction() {

        const meetTheTeamTeaserSlider = document.querySelectorAll<HTMLElement>(".meet-the-team-teaser .meet-the-team-teaser-list");
        meetTheTeamTeaserSlider.forEach((teamSlider) => {
      
            const items = teamSlider.querySelectorAll('.logo-img-carousel-item');
            if (items.length > 6) {
                items.forEach((item, index) => {
                    if (index >= 6) {
                        item.remove();
                    }
                });
            }

 
            const slider = tns({
                container: teamSlider,
                items: 1,
                loop: false,
                gutter: 0,
                nav: true,
                controls: true,
                edgePadding: 0,
                controlsText: [
                    '<svg aria-hidden="true" class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-left-white"></use></svg>',
                    '<svg aria-hidden="true" class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-right-white"></use></svg>'
                ],
                responsive: {
                    640: {
                        items: 2,
                        gutter: 24,
                        nav: false
                    },
                    1024: {
                        items: 3,
                        gutter: 24,
                        nav: false,
                        slideBy: 'page'
                    }
                }
            });

            const wrapper = teamSlider.closest('.logo-img-carousel-wrap');
            if (!wrapper) return;

            const tnsOuter = wrapper.querySelector('.tns-outer');
            if (tnsOuter instanceof HTMLElement) {
                tnsOuter.style.overflow = 'hidden';
            }

            // Enhanced dot navigation with onclick handlers
            const updateVisibleDots = () => {
                if (window.innerWidth < 640) {
                    const info = slider.getInfo();
                    const currentIndex = info.index;

                    const navContainer = wrapper.querySelector('.tns-nav') as HTMLElement;
                    if (!navContainer) return;

                    navContainer.style.display = 'flex';

                    const navButtons = navContainer.querySelectorAll<HTMLElement>('button');

                    if (navButtons.length > 3) {
                        navButtons.forEach(btn => {
                            btn.style.display = 'none';
                            btn.classList.remove('tns-nav-active');
                        });

                        const baseIndex = Math.floor(currentIndex / 3) * 3;
                        const activeDot = currentIndex % 3;

                        for (let i = 0; i < 3 && (baseIndex + i) < navButtons.length; i++) {
                            const btn = navButtons[i];
                            btn.style.display = '';

                            btn.onclick = function () {
                                const targetSlide = baseIndex + i;
                                slider.goTo(targetSlide);
                            };
                        }

                        if (navButtons[activeDot]) {
                            navButtons[activeDot].classList.add('tns-nav-active');
                        }
                    }
                }
            };

            slider.events.on('indexChanged', updateVisibleDots);
            setTimeout(updateVisibleDots, 100);
        });

        // Initialize all other sliders (excluding meet-the-team-teaser)
        const allSliders = document.querySelectorAll<HTMLElement>(".logo-img-slider");
        if (!allSliders || allSliders.length === 0) {
            return;
        }
        
        allSliders.forEach((slider) => {
            if (!slider) { return};

            if (slider.closest('.meet-the-team-teaser')) return;
            
             const wrapper = slider.closest(".logo-img-carousel-wrap");
             if (!(wrapper instanceof HTMLElement)) return;
             const items = slider.querySelectorAll(".logo-img-carousel-item").length;
            
            // Check if this is the team slider
            const isTeamSlider = slider.closest('.our-team-section-v2') !== null;
            
            if (!isTeamSlider && items < 5 && window.innerWidth >= 1024) {
                slider.classList.remove("logo-img-slider");
                wrapper.style.paddingBottom = "0";
                return;
            }
            if (slider.classList.contains("tns-initialized")) return;
            if (typeof tns === 'function') {
                const enableAutoScroll = document.querySelector('.logo-img-carousel-list-auto-scroll') !== null;
                
                // Team slider specific configuration (without slideBy: 'page')
                if (isTeamSlider) {
                    const instance = tns({
                        container: slider,
                        items: 1,
                        loop: false,
                        gutter: 0,
                        nav: true,
                        controls: true,
                        edgePadding: 0,
                        controlsText: [
                            '<svg aria-hidden="true" class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-left-white"></use></svg>',
                            '<svg aria-hidden="true" class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-right-white"></use></svg>'
                        ],
                        responsive: {
                            640: {
                                items: 2,
                                gutter: 24,
                                nav: false
                            },
                            1024: {
                                items: 3,
                                gutter: 24,
                                nav: false
                            }
                        }
                    });
                    slider.classList.add("tns-initialized");

                    // Apply overflow hidden to the tns-outer container
                    const tnsOuter = wrapper.querySelector('.tns-outer');
                    if (tnsOuter instanceof HTMLElement) {
                        tnsOuter.style.overflow = 'hidden';
                    }

                    // Standard dot navigation (without onclick handlers)
                    const updateVisibleDots = () => {
                        if (window.innerWidth < 640) {
                            const info = instance.getInfo();
                            const currentIndex = info.index;
                            
                            const navContainer = wrapper.querySelector('.tns-nav') as HTMLElement;
                            if (navContainer) {
                                navContainer.style.display = 'flex';
                            }
                            
                            const navButtons = wrapper.querySelectorAll<HTMLElement>('.tns-nav button');

                            if (navButtons.length > 3) {
                                navButtons.forEach((btn) => {
                                    btn.style.display = 'none';
                                });

                                const dotIndex = currentIndex % 3;

                                for (let i = 0; i < 3 && i < navButtons.length; i++) {
                                    navButtons[i].style.display = '';
                                }

                                navButtons.forEach((btn, idx) => {
                                    if (idx === dotIndex) {
                                        btn.classList.add('tns-nav-active');
                                    } else if (idx < 3) {
                                        btn.classList.remove('tns-nav-active');
                                    }
                                });
                            }
                        }
                    };

                    instance.events.on('indexChanged', updateVisibleDots);
                    setTimeout(updateVisibleDots, 100);
                } else {
                    // Default logo carousel configuration
                 const instance = tns({
                     container: slider,
                     items: 1,
                     loop: enableAutoScroll,
                     slideBy: 'page',
                     autoplay: enableAutoScroll,
                     autoplayTimeout: 5000,
                     autoplayButtonOutput: false,
                     autoplayResetOnVisibility: false,
                     speed: 1000,
                     mode: 'carousel',
                     animateIn: 'tns-fadeIn',
                     animateOut: 'tns-fadeOut',
                     controlsText: [
                         '<svg aria-hidden="true" class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-left-white"></use></svg>',
                         '<svg aria-hidden="true" class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-right-white"></use></svg>'
                     ],
                     responsive: {
                         1024: {
                             items: 2
                         },
                         1200: {
                             items: 5
                         }
                     }
                 });
                 slider.classList.add("tns-initialized");

                instance.events.on("indexChanged", () => manageTNSPaginationDots(instance, '.logo-img-carousel'));
                setTimeout(() => manageTNSPaginationDots(instance, '.logo-img-carousel'), 150);

                // Restart autoplay after manual navigation with arrow buttons
                if (enableAutoScroll) {
                    const controlsContainer = slider.closest('.logo-img-carousel-wrap');
                    const prevBtn = controlsContainer?.querySelector('.tns-controls [data-controls="prev"]');
                    const nextBtn = controlsContainer?.querySelector('.tns-controls [data-controls="next"]');
                    
                    prevBtn?.addEventListener('click', () => {
                        setTimeout(() => {
                                instance.play();
                        }, 100);
                    });
                    
                    nextBtn?.addEventListener('click', () => {
                        setTimeout(() => {
                                instance.play();
                        }, 100);
                    });
                   }
                }
            } else {
                  console.warn("Tiny Slider is not loaded.");
              }
         });
     }
 }
export const LogoImgSliderTest = {LogoImgSlider};
// INTERACTIVE IMAGE POPOVER JS STRATS HERE
export class PopoverBts {
    private static instance: PopoverBts;

    constructor() {
        this.handlePopoverButton();
    }

    static getInstance(): PopoverBts {
        if (!PopoverBts.instance) {
            PopoverBts.instance = new PopoverBts();
        }
        return PopoverBts.instance;
    }
    private handlePopoverButton() {
        if (window.innerWidth > 768) {

            const openPopoverBtns = document.querySelectorAll('.open-modal-btn');
            const closePopoverBtns = document.querySelectorAll('.close-popover');
            openPopoverBtns.forEach(function (btn) {
                btn.addEventListener('click', function () {
                    const popoverId: any = btn.getAttribute('data-popover-target');
                    const popover: any = document.getElementById(popoverId) as HTMLElement;
                    if (popover) {
                        popover.style.display = "flex";
                        popover.style.zIndex = "11";
                    }
                });
            });
            closePopoverBtns.forEach(function (btn) {
                btn.addEventListener('click', function () {
                    const popover: any = btn.closest('[data-popover]');
                    if (popover) {
                        popover.style.display = "none";
                        popover.style.zIndex = "5";
                    }
                });
            });
        }
        if (window.innerWidth <= 768) {
            const openModalBtns = document.querySelectorAll('.open-modal-btn');
            const popoverMobile: HTMLElement | null = document.querySelector('.popover-mobile');
            if (popoverMobile != null) {
                popoverMobile.style.display = "none";
                openModalBtns.forEach(function (btn) {
                    btn.addEventListener('click', function () {
                        const popoverModal: any = btn.nextElementSibling;
                        const popoverContent = popoverModal.innerHTML;
                        // Copy popover content to popover-mobile
                        popoverMobile.innerHTML = popoverContent;

                        // Show popover-mobile
                        popoverMobile.style.display = "flex";

                        // Add event listener to the popoverMobile button
                        const popoverMobileBtn = popoverMobile.querySelector('.close-popover');
                        popoverMobileBtn?.addEventListener('click', function () {
                            // Hide popover-mobile when popoverMobileBtn is clicked
                            popoverMobile.style.display = "none";
                        });
                        // Add event listener to the document for clicks
                        document.addEventListener('click', function (event: any) {
                            const isClickedInsidePopoverMobile = popoverMobile.contains(event.target);
                            const isClickedInsideOpenModalBtn = Array.from(openModalBtns).some(function (openModalBtn) {
                                return openModalBtn.contains(event.target);
                            });
                            // Hide popover-mobile if click is outside
                            if (!isClickedInsidePopoverMobile && !isClickedInsideOpenModalBtn) {
                                popoverMobile.style.display = "none";
                            }
                        });
                    });
                });
            }
        }
    }
}
// INTERACTIVE IMAGE POPOVER JS ENDS HERE

//MultiImage Component
export class MultiImageModal {
    private static instance: MultiImageModal;
    private multiImgSlideIndex = 1;
    private readonly multiImgSlides = document.getElementsByClassName("pop-up-img-slider");

    static getInstance(): MultiImageModal {
        if (!MultiImageModal.instance) {
            MultiImageModal.instance = new MultiImageModal();
        }
        return MultiImageModal.instance;
    }

    constructor() {
        const multiImageSection = document.querySelector(".multi-img-section");
        if (multiImageSection) {
            const multiImage = document.querySelectorAll('.multi-img-item');
            const closeBtn: any = document.querySelector('#multiImageModal .close');
            const prevBtn: any = document.querySelector('#multiImageModal .prev');
            const nextBtn: any = document.querySelector('#multiImageModal .next');


            closeBtn?.addEventListener('click', () => {
                (document.getElementById("multiImageModal") as HTMLElement).style.display = "none";
                document.body.style.overflow = '';
            })
            if (prevBtn) {
                prevBtn.addEventListener("click", () => this.plusMultiSlides(-1));
            }
            if (nextBtn) {
                nextBtn.addEventListener("click", () => this.plusMultiSlides(1));
            }


            multiImage?.forEach((item) => {
                item.addEventListener('click', () => {
                    const imageIdAttr = item.children[0]?.getAttribute('data-image-id');
                    const imageId = imageIdAttr !== null ? Number(imageIdAttr) : 0;
                    this.openModalMultiImg(imageId as any);
                });
            });
        }
    }

    public openModalMultiImg(imageId: string | null) {
        let modal = document.getElementById("multiImageModal");
        if (modal) {
            modal.style.display = "flex";
            document.body.style.overflow = 'hidden';
        }

        this.currentMultiSlide(imageId as any);
    }

    public plusMultiSlides(n: number) {

        const prevBtn: any = document.querySelector('#multiImageModal .prev');
        const nextBtn: any = document.querySelector('#multiImageModal .next');

        if (this.multiImgSlideIndex >= this.multiImgSlides.length - 1 && n > 0) {
            this.multiImgSlideIndex = this.multiImgSlideIndex + n;
            this.showMultiSlides(this.multiImgSlideIndex);
            this.disableButton(nextBtn, true);
            this.disableButton(prevBtn, false);
        }
        else if (this.multiImgSlideIndex <= 2 && n < 0) {
            this.multiImgSlideIndex = this.multiImgSlideIndex + n;
            this.showMultiSlides(this.multiImgSlideIndex);
            this.disableButton(nextBtn, false);
            this.disableButton(prevBtn, true);
        }
        else {
            this.multiImgSlideIndex = this.multiImgSlideIndex + n;
            this.showMultiSlides(this.multiImgSlideIndex);
            this.disableButton(nextBtn, false);
            this.disableButton(prevBtn, false);
        }
    }

    public disableButton(btn: HTMLButtonElement | null, isDisabled: boolean) {
        if (btn) {
            btn.disabled = isDisabled;
        }
    }

    public currentMultiSlide(n: number) {

        this.multiImgSlideIndex = n;
        this.showMultiSlides(this.multiImgSlideIndex);

        const prevBtn: any = document.querySelector('#multiImageModal .prev');
        const nextBtn: any = document.querySelector('#multiImageModal .next');
        const multiImgSlides = document.getElementsByClassName("pop-up-img-slider");

        if (this.multiImgSlideIndex === multiImgSlides.length) {
            this.disableButton(nextBtn, true);
        }
        else if (this.multiImgSlideIndex === 1) {
            this.disableButton(prevBtn, true);
            this.disableButton(nextBtn, false);
        }
        else {
            this.disableButton(nextBtn, false);
            this.disableButton(prevBtn, false);
        }

    };

    public showMultiSlides(n: number) {
        let i;
        const multiImgSlides = document.getElementsByClassName("pop-up-img-slider");
        if (n > multiImgSlides.length) {
            this.multiImgSlideIndex = 1;
        }
        if (n < 1) {
            this.multiImgSlideIndex = multiImgSlides.length;
        }
        for (i = 0; i < multiImgSlides.length; i++) {
            (multiImgSlides[i] as HTMLElement).style.display = "none";
        }
        (multiImgSlides[this.multiImgSlideIndex - 1] as HTMLElement).style.display = "flex";
    };
}
//Inspirational gallery is nonces and support multiple gallery sections on the same page
export class InspirationGallerySlider {
    private static instance: InspirationGallerySlider;
    private readonly sections: HTMLElement[];
    constructor() {
        this.sections = Array.from(document.querySelectorAll<HTMLElement>('.inspiration-gallery'));
        if (this.sections?.length) {
            this.sections?.forEach(section => this.init(section));
        }       
    }

    static getInstance(): InspirationGallerySlider {
        if (!InspirationGallerySlider.instance) {
            InspirationGallerySlider.instance = new InspirationGallerySlider();
        }
        return InspirationGallerySlider.instance;
    }
    private init(section: HTMLElement) {
        const modal = section.querySelector<HTMLElement>("#galleryModal")!;
        const imageSlides = Array.from(section.getElementsByClassName("pop-up-slider")) as HTMLElement[];
        const galleryImages = section.querySelectorAll('.photo-card-item');

        if (!modal || imageSlides.length === 0) return;
        
        const closeBtn = modal.querySelector<HTMLButtonElement>('.close');
        const prevBtn = modal.querySelector<HTMLButtonElement>('.prev');
        const nextBtn = modal.querySelector<HTMLButtonElement>('.next');
    
        let currentSlideIndex = 1;
    
        const showSlides = (n: number) => {
          if (imageSlides.length === 0) return;
          if (n > imageSlides.length) currentSlideIndex = 1;
          if (n < 1) currentSlideIndex = imageSlides.length;
    
          imageSlides?.forEach(slide => (slide.style.display = "none"));
          imageSlides[currentSlideIndex - 1].style.display = "flex";
    
          prevBtn!.disabled = currentSlideIndex === 1;
          nextBtn!.disabled = currentSlideIndex === imageSlides.length;
        };
    
        const openModalImg = (slideIndex: number) => {
          if (!modal) return;
          modal.style.display = "flex";
          document.body.style.overflow = 'hidden';
          currentSlideIndex = slideIndex;
          showSlides(currentSlideIndex);
        };
    
        const plusSlides = (n: number) => {
          currentSlideIndex += n;
          showSlides(currentSlideIndex);
        };
    
        closeBtn?.addEventListener("click", () => {
          if (modal) modal.style.display = "none";
          document.body.style.overflow = "";
        });
    
        prevBtn?.addEventListener("click", () => plusSlides(-1));
        nextBtn?.addEventListener("click", () => plusSlides(1));
    
        galleryImages?.forEach((item) => {
          if (!item.querySelector(".video-area")) {
            const imageIdAttr = item.children[0]?.getAttribute("data-photo-id");
            const imageId = imageIdAttr ? Number(imageIdAttr) : 1;
            item?.addEventListener("click", () => openModalImg(imageId));
          }
        });
    
        this.copySocialLink(section);
      }

    public copySocialLink(section: HTMLElement) {

        const copyBlogLink: NodeListOf<Element> = section.querySelectorAll(".copy_link_share");

        // Loop through each element to add event listeners
        copyBlogLink?.forEach((element: Element) => {
            if (!element) return;
            element.addEventListener("click", (event: Event) => {
                event.preventDefault();
                let urlImg: string = decodeURIComponent(window.location.href);
                navigator.clipboard.writeText(urlImg)
                    .then(() => {
                        console.log('URL copied to clipboard');
                        alert(`${urlImg}\n Copied to Clipboard`);
                    })
                    .catch((err: any) => {
                        console.error('Failed to copy URL: ', err);
                    });
            });
        });

    }

}

export class TransformationSlider {
    private static instance: TransformationSlider;

    public static getInstance(): TransformationSlider {
        if (!TransformationSlider.instance) {
            TransformationSlider.instance = new TransformationSlider();
        }
        return TransformationSlider.instance;
    }

    constructor() {
        this.transFormationSlider();
    }

    private transFormationSlider() {
        let transfSlider = document.querySelector(".transformation-slider") as HTMLElement;
        if (transfSlider) {
            tns({
                container: transfSlider,
                items: 1,
                loop: false,
                gutter: 10,
                controlsText: ['<svg aria-hidden="true" class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-left-white"></use></svg>', '<svg aria-hidden="true"  class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-right-white"></use></svg>'],
            });
        }
    }
}

export class SolutionMagazineSlider {
    private static instance: SolutionMagazineSlider;

    public static getInstance(): SolutionMagazineSlider {
        if (!SolutionMagazineSlider.instance) {
            SolutionMagazineSlider.instance = new SolutionMagazineSlider();
        }
        return SolutionMagazineSlider.instance;
    }

    constructor() {
        this.solutionMagazineSlider();
        const solMagazineSlider = document.querySelector(".solution-magazine-slider");
        // Add event listener for slider change
        solMagazineSlider?.addEventListener('transitionend', this.handleSolutionSliderChange);
        // Initial setup with a slight delay to ensure everything is loaded
        setTimeout(this.handleSolutionSliderChange, 100);
    }

    private solutionMagazineSlider() {

        //SOLUTION MAGAZINE SECTION SLIDER JS STARTS HERE
        let solMagazineSlider = document.querySelector(".solution-magazine-slider");
        if (solMagazineSlider) {
            tns({
                container: solMagazineSlider,
                items: 1,
                loop: false,
                gutter: 10,
                controlsText: ['<svg aria-hidden="true" class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-left-white"></use></svg>', '<svg aria-hidden="true"  class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-right-white"></use></svg>'],
                navContainer: "#magazine-thumbnails",
                navAsThumbnails: true,
                swipeAngle: false,
                onInit: this.handleSolutionSliderChange
            });
        }
    }

    private handleSolutionSliderChange() {

        const sliderElement = document.querySelector('.solution-magazine-slider') as HTMLLIElement;
        if (sliderElement) {

            const activeIndex = Array.from(sliderElement.children).findIndex(child => child.classList.contains('tns-slide-active'));

            const thumbnails = document.querySelectorAll('.thumbnails li') as any;
            const totalThumbnails = thumbnails.length;

            thumbnails.forEach(function (thumbnail: any) {
                thumbnail.style.display = 'none';
            });

            // Calculate the range of thumbnails to show
            const startIndex = Math.max(0, activeIndex - 2);
            const endIndex = Math.min(totalThumbnails, startIndex + 6);
            const numVisibleThumbnails = endIndex - startIndex;

            // Show the thumbnails within the range
            for (let i = startIndex; i < endIndex; i++) {
                thumbnails[i].style.display = 'inline-block';
            }

            // Adjust thumbnails if less than 6 are visible
            const additionalThumbnails = 6 - numVisibleThumbnails;
            if (additionalThumbnails > 0) {
                const startIndexToAdjust = Math.max(0, startIndex - additionalThumbnails);
                for (let j = startIndexToAdjust; j < startIndex; j++) {
                    thumbnails[j].style.display = 'inline-block';
                }
            }
        }
    }

}
// COLOR VISUALIZER SECTION SLIDER CHANGES STARTS HERE
export class ColorVisualiserSlider {
    private static instance: ColorVisualiserSlider;

    tinySliderInstance: any;
    allThumbnails: NodeListOf<Element> | undefined;
    dropdownBtn: HTMLElement | undefined;
    dropdownContent: any;
    btnContent: any;

    public static getInstance(): ColorVisualiserSlider {
        if (!ColorVisualiserSlider.instance) {
            ColorVisualiserSlider.instance = new ColorVisualiserSlider();
        }
        return ColorVisualiserSlider.instance;
    }

    constructor() {
        let colorVisualSlider = document.querySelector(".color-visualizer-carousel");
        if (colorVisualSlider) {
            this.tinySliderInstance = tns({
                container: '.color-visualizer-carousel',
                items: 1,
                slideBy: 'page',
                autoplay: false,
                controls: true,
                loop: false,
                gutter: 10,
                controlsText: [
                    '<svg aria-hidden="true" class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-left-white"></use></svg>',
                    '<svg aria-hidden="true" class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-right-white"></use></svg>'
                ],
                navAsThumbnails: true,
                nav: false,
            });

            this.allThumbnails = document.querySelectorAll('.thumbnails ul li');
            this.dropdownBtn = document.querySelector('.dropdown-btn') as HTMLElement;
            this.dropdownContent = document.querySelector('.dropdown-content');
            this.btnContent = this.dropdownBtn?.querySelector('.dropdown-btn-content');

            this.init();
        }
    }

    insertCheckIcon(container: Element) {
        const thumbIcon = container.querySelector('.thumb-icon');
        if (thumbIcon) {
            thumbIcon.innerHTML = `
          <svg aria-hidden="true"  class="icon">
            <use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#check-mark"></use>
          </svg>
        `;
        }
    }

    insertChevronIcon(container: any) {
        const thumbIcon = container.querySelector('.thumb-icon');
        if (thumbIcon) {
            thumbIcon.innerHTML = `
          <svg aria-hidden="true" class="icon">
            <use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-down"></use>
          </svg>
        `;
        }
    }

    activateImageById(id: string | null) {
        document.querySelectorAll('.color-visualizer-item')?.forEach(item => {
            item?.classList.remove('active');
            if (item?.getAttribute('data-id') === id) item?.classList.add('active');
        });

        this.allThumbnails?.forEach(thumb => {
            thumb?.classList.remove('active-thumb');
            if (thumb?.getAttribute('data-id') === id) thumb?.classList.add('active-thumb');
        });

        this.dropdownContent?.querySelectorAll('li').forEach((li: any) => {
            li?.classList.remove('active-thumb');
            if (li?.getAttribute('data-id') === id) li?.classList.add('active-thumb');
        });

        this.dropdownContent?.querySelectorAll('li .thumb-icon').forEach((icon: any) => (icon.innerHTML = ''));
        document.querySelectorAll('.thumbnails ul li .thumb-icon').forEach(icon => (icon.innerHTML = ''));

        const activeDropdownThumb = this.dropdownContent?.querySelector(`li[data-id="${id}"] .palette-card`);
        const activeDesktopThumb = document.querySelector(`.thumbnails ul li[data-id="${id}"] .palette-card`);
        if (activeDropdownThumb) this.insertCheckIcon(activeDropdownThumb);
        if (activeDesktopThumb) this.insertCheckIcon(activeDesktopThumb);

        const activeLi = this.dropdownContent?.querySelector(`li[data-id="${id}"] .palette-card`);
        if (activeLi) {
            if (this.btnContent) this.btnContent.innerHTML = '';
            const clonedCard = activeLi.cloneNode(true);
            this.insertChevronIcon(clonedCard);
            if (this.btnContent) this.btnContent.appendChild(clonedCard);
        }
    }

    updateVisibleThumbnailsBySlide(currentSlide: Element) {
        const imageItems = currentSlide?.querySelectorAll('.color-visualizer-item');
        const idsToShow: string[] = [];

        imageItems?.forEach(img => {
            const id = img.getAttribute('data-id');
            if (id) idsToShow.push(id);
        });

        this.allThumbnails?.forEach(thumb => {
            const id = thumb?.getAttribute('data-id');
            if (!id) return;
            (thumb as HTMLElement).style.display = idsToShow?.includes(id) ? 'inline-block' : 'none';
        });

        if (this.dropdownContent) this.dropdownContent.innerHTML = '';
        this.allThumbnails?.forEach(thumb => {
            const id = thumb?.getAttribute('data-id') ?? '';
            if (idsToShow?.includes(id)) {
                const clone = thumb?.cloneNode(true) as HTMLLIElement;
                clone?.setAttribute('data-id', id);
                this.dropdownContent?.appendChild(clone);

                clone.addEventListener('click', () => {
                    this.activateImageById(id);
                    if (this.dropdownContent) this.dropdownContent.style.display = 'none';
                    const paletteCard = clone.querySelector('.palette-card');
                    if (paletteCard) {
                        const clonedCard = paletteCard.cloneNode(true);
                        this.insertChevronIcon(clonedCard); // Add chevron icon
                        if (this.btnContent) {
                            this.btnContent.innerHTML = '';
                            this.btnContent.appendChild(clonedCard);
                        }
                    }
                });
            }
        });
    }

    init() {
        const thumbnailsContainer = document.querySelector('.color-visualizer-section .thumbnails');
        const dropdownContainer = document.querySelector('.color-visualizer-section .thumbnails-dropdown');
        if (this.allThumbnails?.length) {
            let allMissingImages = true;
            let allMissingTitles = true;

            this.allThumbnails?.forEach(thumb => {
                const img = thumb?.querySelector('.color-vir-li-img img') as HTMLImageElement;
                const rawSrc = img?.getAttribute('src');
                const textSpan = thumb?.querySelector('.color-var-li-text');
                if (!rawSrc && img) {
                    // Hide image if src is missing to avoid broken image
                    img.style.display = 'none';
                } else if (rawSrc && rawSrc.trim() !== '') {
                    // At least one image has a src
                    allMissingImages = false;
                }
                // At least one pallette has title
                if (textSpan?.textContent?.trim()) {
                    allMissingTitles = false;
                }
                thumb?.addEventListener('click', () => {
                    const id = thumb?.getAttribute('data-id');
                    this.activateImageById(id);
                });
            });
            //Class gets added only when all the images in color pallette doesn't have src
            if (allMissingImages) {
                thumbnailsContainer?.classList.add('thumbnails-only-title');
                dropdownContainer?.classList.add('thumbnails-only-title');
            }
            //Class gets added only when all the images in color pallette doesn't have title
            if (allMissingTitles) {
                thumbnailsContainer?.classList.add('thumbnails-only-image');
                dropdownContainer?.classList.add('thumbnails-only-image');
            }
        }

        this.dropdownBtn?.addEventListener('click', (e: any) => {
            e.stopPropagation();
            if (!this.dropdownContent) return;
            const isOpen = this.dropdownContent?.style.display === 'block';
            this.dropdownContent.style.display = isOpen ? 'none' : 'block';
            if (!isOpen) {
                const activeThumb = this.dropdownContent?.querySelector('.active-thumb .palette-card');
                if (activeThumb) {
                    if (this.btnContent)
                        this.btnContent.innerHTML = '';
                    const clonedCard = activeThumb.cloneNode(true);
                    this.insertChevronIcon(clonedCard);
                    if (this.btnContent)
                        this.btnContent.appendChild(clonedCard);
                }
            }
        });

        document.addEventListener('click', e => {
            const target = e.target as HTMLElement | null;
            if (target && !target.closest('.thumbnails-dropdown') && !target.closest('.dropdown-btn') && !target.closest('.bio-btn')) {
               if(this.dropdownContent) this.dropdownContent.style.display = 'none';
            }
        });

        this.tinySliderInstance?.events?.on('indexChanged', (info: any) => {
            const currentSlide = info.slideItems[info.index];
            currentSlide?.querySelectorAll('.color-visualizer-item').forEach((img: any, idx: any) => {
                img?.classList.remove('active');
                if (idx === 0) img?.classList.add('active');
            });
            this.updateVisibleThumbnailsBySlide(currentSlide);

            const activeImg = currentSlide?.querySelector('.color-visualizer-item.active');
            if (activeImg) {
                this.activateImageById(activeImg.getAttribute('data-id'));
            }
        });

        window.addEventListener('load', () => {
            const checkSliderReady = setInterval(() => {
                const sliderInfo = this.tinySliderInstance?.getInfo();
                if (sliderInfo && sliderInfo?.slideItems?.length > 0) {
                    clearInterval(checkSliderReady);
                    const currentSlide = sliderInfo.slideItems[sliderInfo.index];
                    this.updateVisibleThumbnailsBySlide(currentSlide);

                    const activeImg = currentSlide.querySelector('.color-visualizer-item.active');
                    if (activeImg) {
                        this.activateImageById(activeImg.getAttribute('data-id'));
                    }
                }
            }, 100);
        });
        // Modal image view
        const modal = document.getElementById('color-image-modal');
        const modalImg = document.getElementById('color-modal-img');
        const closeModalBtn = document.querySelector('.visual-close');

        document.querySelectorAll('.color-visualizer-item img')?.forEach(img => {
            img?.addEventListener('click', function (this: HTMLImageElement) {
                if (modal) {
                    modal.style.display = 'flex';
                }
                if (modalImg) {
                    const imgElement = modalImg as HTMLImageElement; // Cast modalImg to HTMLImageElement
                    imgElement.src = this.getAttribute('data-large') ?? '';  // `this` refers to the clicked <img>
                    imgElement.alt = this.alt || '';  // `this` refers to the clicked <img>
                }
            });
        });


        closeModalBtn?.addEventListener('click', function () {
            if (modal) modal.style.display = 'none';
        });

        modal?.addEventListener('click', function (event) {
            if (event.target === modal) {
                modal.style.display = 'none';
            }
        });
    }
}

//COLOR VISUALIZER SECTION SLIDER CHANGES END HERE


// COMPONENT - 68 - EVENT TEASER COMPONENT SLIDER TS STARTS HERE
export class EventTeaserSlider {
    private static instance: EventTeaserSlider | null = null;

    constructor() {
        this.initSlider();
    }

      // Public method to get the single instance of the class
      public static getInstance(): EventTeaserSlider {
        EventTeaserSlider.instance ??= new EventTeaserSlider();
        return EventTeaserSlider.instance;
    }

    public initSlider(): void {
        const eventTeaserSlider = document.querySelector(".upcoming-events-slider .card-list") as HTMLElement;

        if (eventTeaserSlider) {
            
            tns({
                container: eventTeaserSlider,
                items: 1,
                loop: false,
                slideBy: 'page',
                nav: true,
                navPosition: "bottom",
                // controlsPosition: "bottom",
                controlsText: ['<svg aria-hidden="true" class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-left-white"></use></svg>', '<svg aria-hidden="true"  class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-right-white"></use></svg>'],
                responsive: {
                    1024: {
                        items: 2,
                    },
                    1200: {
                        items: 3,
                    }
                }
            });
        }
    }
}


// COMPONENT - 68 - EVENT TEASER COMPONENT SLIDER TS ENDS HERE

/*********** Start Brand Popup Modal Photos Slider  ***************/
export class BrandPopupPhotoGallery {
    private static instance: BrandPopupPhotoGallery | null = null;

    constructor() {
        this.initSlider();
    }

    public static getInstance(): BrandPopupPhotoGallery {
        BrandPopupPhotoGallery.instance ??= new BrandPopupPhotoGallery();
        return BrandPopupPhotoGallery.instance;
    }

    public initSlider(): void {
        const nblyPhotoSlider = document.querySelector(".brand-popup-photo-gallery-slider") as HTMLElement;
        
        if (nblyPhotoSlider) {
            tns({
                container: nblyPhotoSlider,
                items: 1,
                loop: false,
                slideBy: 'page',
                nav: false,
                navPosition: "bottom",
                controlsText: ['<svg aria-hidden="true" class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-left-white"></use></svg>', '<svg aria-hidden="true"  class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-right-white"></use></svg>'],
                responsive: {
                    1024: {
                        items: 2,
                    },
                    1200: {
                        items: 3,
                    }
                }
            });
        }
    }
}


/*********** END Brand Popup Modal Photos Slider  ***************/


/*********** Start Brand Popup Modal Customer review Slider  ***************/

export class BrandPopupReviewSlider {
    private static instance: BrandPopupReviewSlider | null = null;

    constructor() {
        this.initSlider();
    }

    public static getInstance(): BrandPopupReviewSlider {
        BrandPopupReviewSlider.instance ??= new BrandPopupReviewSlider();
        return BrandPopupReviewSlider.instance;
    }

    public initSlider(): void {
        const brandReviewSlider = document.querySelector(".brand-popup-review-slider") as HTMLElement;
        
        if (brandReviewSlider) {
            tns({
                container: brandReviewSlider,
                items: 2,
                loop: false,
                slideBy: 'page',
                nav: false,
                navPosition: "bottom",
                controlsText: ['<svg aria-hidden="true" class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-left-white"></use></svg>', '<svg aria-hidden="true"  class="slider-control"><use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#chevron-right-white"></use></svg>'],
                gutter: 12
            });
        }
    }
}

/*********** END Brand Popup Modal Customer review Slider  ***************/


document.addEventListener("DOMContentLoaded", () => {
    const asideDiv = new AsideDiv();
    const offersliderElement = new TinySlider();
    const customerReviewSlider = new CustomerReviewSlider();
    const photoGallerySlider = new PhotoGallerySlider();
    const chargerServiceSlider = new ChargerServiceSlider();
    const windowSlider = new WindowSlider();
    
    LogoImgSlider.getInstance();
    PopoverBts.getInstance();
    MultiImageModal.getInstance();
    InspirationGallerySlider.getInstance();
    TransformationSlider.getInstance();
    SolutionMagazineSlider.getInstance();
    ColorVisualiserSlider.getInstance();
    EventTeaserSlider?.getInstance();
    

    const bioButtons = document.querySelectorAll('.meet-the-team-teaser .bio-btn');
    if (bioButtons.length > 0) {
        const { Concert } = require('./teams');
        Concert.getInstance();
    }


    // If the user is localize and DBA checkbox is checked then adding class menu-local in header wrapper
    setTimeout(() => {
        const screenType = reportScreenSize();
        if (screenType !== ScreenType.Desktop) {
            replaceLeadCtaWithClick();
            stickyFooter();
        }
    }, 1000);

    // If the user is localise then replacing the national banner information with local banner information
    addLocalizationHeaderBannerInformationLocal();
    registerClickToCallAnalytics();
    if(isTouchDevice()){
        clickToCallHandler();
    }
    attachEventListnerForCoupon8();
    const OfferSection = document.querySelector('.offers-block-section');
    //To avoid event to get attached twice to asv dynamic offer teaser as it contains offers-block-section class
    if (!OfferSection?.classList.contains('dynamic-offer-teaser-component')) {
        attachEventListnerForCoupon11();
    }
    addNblyHeaderInformation();
    applyTruncateIfAutoExpandDisabled();
    localDynamicMenuLargeMediaTile();
    localDynamicMenuLarge2575MediaTile();
    localDynamicMenuLarge5050MediaTile();
    updatePhoneNumberComponent();
    //Read More function call//
    readMoreButton();
    dynamicMenuServiceAccordion();
    dynamicScroll();
    expandAccordionOnLoad();
    const screenType = reportScreenSize();
    if (screenType === ScreenType.Desktop) {
        initializeNavDropdown();
    }

    pricingComponent7();
    dynamicPricingSection();
    handleMobileDesktopSubmenuClicks();
    handleNameFormatting();

});

//Read More//
function readMoreButton() {
    const readMoreWrap = document.querySelector('.read-more-wrap') as HTMLElement;
    if (readMoreWrap) {
        const originalContent = readMoreWrap.innerHTML.trim();
        const words = originalContent.split(/\s+/);

        // Check if the content exceeds 400 words
        if (words.length > 100) {
            // Truncate the text to 400 words
            const truncatedContent = words.slice(0, 100).join(' ') + '...';
            readMoreWrap.innerHTML = truncatedContent;

            // Create and add the "Read More" button
            const readMoreButton = document.createElement('button');
            readMoreButton.textContent = '...Read More';
            readMoreButton.className = "red-more-button";
            readMoreButton.style.width = "fit-content";
            readMoreWrap.appendChild(readMoreButton);

            if (readMoreButton) {
                readMoreButton.addEventListener('click', function () {
                    if (readMoreButton.textContent === "...Read More") {
                        // Show the full content
                        readMoreWrap.innerHTML = originalContent;
                        readMoreButton.textContent = "...Read Less";
                        readMoreWrap.appendChild(readMoreButton); // Re-attach the button
                    } else {
                        // Re-truncate the content
                        readMoreWrap.innerHTML = truncatedContent;
                        readMoreButton.textContent = "...Read More";
                        readMoreWrap.appendChild(readMoreButton); // Re-attach the button
                    }
                });
            }
        }
    }
 }
 //End//
export async function addLocalizationHeaderMenuLocal() {
    try {
        const headerWrapper = document.querySelector(".header-wrapper") as HTMLElement;
        const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
        const brandData = await getBrandDetailsFromBrandJson(conceptCode);
        const dbaName = localStorage.getItem('dbaName');
        if (headerWrapper && brandData?.show_localheader_dba_center && dbaName) {
            headerWrapper.classList.add("menu-local");
        } else {
            headerWrapper?.classList.remove("menu-local");
        }
    } catch (error) {
        console.error("An error occurred in the addLocalizationHeaderMenuLocal function:", error);
    }

}

async function replaceLeadCtaWithClick() {
    let brandDetails = localStorage.getItem("brandDetails") as any;
    const fullAttrOnLoad = localStorage.getItem("fullAttrOnLoad");
    const dbaName = localStorage.getItem("dbaName");
    let phoneNumber = await getDisplayPhoneNumber();
      const siteConfigDisplayClickToCallCta = localStorage.getItem("siteConfigDisplayClickToCallCta");

    if (brandDetails) {
        brandDetails = JSON.parse(brandDetails);
    }
    const allLeadCtaHeader = document.querySelectorAll(".replace-with-click-to-lead-cta.cta-header-component-lead");
    const allClickToCtaHeader = document.querySelectorAll(".replace-with-click-to-call-cta.cta-header-component-call");
    const allLeadCtaBody = document.querySelectorAll(".replace-with-click-to-lead-cta.cta-body-component-lead");
   
    const isActive = fullAttrOnLoad && isOperationActiveNow(JSON.parse(fullAttrOnLoad)?.hoursofOperation);
    const updateCtaHeader = (element: any) => {
        if (brandDetails?.mobile_cta_text) {
            element.innerHTML = brandDetails.mobile_cta_text;
        }
        if (element) {
            const svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            svgElement.setAttribute("aria-hidden", "true");
            svgElement.innerHTML = brandDetails.mobile_cta_icon;
            element.prepend(svgElement);
        }
        if (element instanceof HTMLAnchorElement && phoneNumber) {
            phoneNumber = String(phoneNumber);
            element.href = `tel:${phoneNumber.replace(/[\(\)\-\s]/g, "")}`;
        }
    };
    const hideElements = (elements: any) => {
        elements.forEach((element: any) => {
            element.classList.add("hidden");
        });
    };
    
    const showElements = (elements: any) => {
        elements.forEach((element: any) => {
            element.classList.remove("hidden");
        });
    };
    
    if (brandDetails?.displayClickToCallCtaHeader && siteConfigDisplayClickToCallCta === 'true' && brandDetails?.displayClickToCallCtaBody && ((!dbaName) || (dbaName && fullAttrOnLoad && isActive))) {
        //replace in header and body
        hideElements(allLeadCtaHeader);
        hideElements(allLeadCtaBody);
        showElements(allClickToCtaHeader);
        allClickToCtaHeader.forEach(updateCtaHeader);
        showElements(allLeadCtaBody);
        allLeadCtaBody.forEach(updateCtaHeader);
     
    }
    else if (brandDetails?.displayClickToCallCtaHeader && siteConfigDisplayClickToCallCta === 'true' && !brandDetails?.displayClickToCallCtaBody && ((!dbaName) || (dbaName && fullAttrOnLoad && isActive))) {
        //replace only in header
        hideElements(allLeadCtaHeader);
        showElements(allLeadCtaBody);
        showElements(allClickToCtaHeader);
        allClickToCtaHeader.forEach(updateCtaHeader);
       
    }  
    else if (!brandDetails?.displayClickToCallCtaHeader && siteConfigDisplayClickToCallCta === 'true' && brandDetails?.displayClickToCallCtaBody && ((!dbaName) || (dbaName && fullAttrOnLoad && isActive))) {
       //replace only in body
        showElements(allLeadCtaHeader);
        showElements(allClickToCtaHeader);
        showElements(allLeadCtaBody);
        allLeadCtaBody.forEach(updateCtaHeader);
       
    }
    else {
        showElements(allLeadCtaHeader);
        showElements(allLeadCtaBody);
        showElements(allClickToCtaHeader);
    }
}

// Function to get the page type

function addLocalizationHeaderBannerInformationLocal() {
    const headerElement = document.getElementById("header-alert") as HTMLDivElement;
    if (headerElement) {
        getMessagesData().then((data) => {
            const informationBanner = data?.informationBanner;
            if (informationBanner) {
                headerElement.classList.remove("alert-warning");
                headerElement.classList.remove("alert-info");
                headerElement.classList.remove("alert-danger");

                if (informationBanner?.alertClass && typeof informationBanner.alertClass === 'string') {
                    headerElement.classList.add(informationBanner.alertClass);
                }

                if (informationBanner?.infotext) {
                    const wysiwygElement = headerElement?.querySelector('.alert-text .wysiwyg') as HTMLElement;
                    if (wysiwygElement) {
                        wysiwygElement.innerHTML = informationBanner?.infotext;
                    }
                }

                if (informationBanner?.infosvg) {
                    const svgElement = headerElement?.querySelector('.inner-alert svg') as HTMLElement;
                    if (svgElement) {
                        svgElement.innerHTML = informationBanner?.infosvg;
                    }
                }

            }
        }).catch((err) => {
            console.log(err, "Error in getting the function addLocalizationHeaderBannerInformationLocal");
        });
    }
}
// Sticky Footer 
async function stickyFooter() {
    const hideOSCTA = localStorage.getItem('siteConfigHideOSCTA');
    if (hideOSCTA === 'true') {
        return;
    }
    
    const footerMainEle = document.querySelector('.sticky-footer') as HTMLElement;
    if (footerMainEle) {
        const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
        const brandData = await getBrandDetailsFromBrandJson(conceptCode);
        const dbaName = localStorage.getItem('dbaName');
        if (brandData?.enable_sticky_footer_national && !dbaName) {
            enableStickyFooter(brandData);
        }
        if (brandData?.enable_sticky_footer_local && dbaName) {
            enableStickyFooter(brandData);
        }

    }
}

export function enableStickyFooter(brandData: any) {
    const footerMainEle = document.querySelector('.sticky-footer') as HTMLElement;
    const footerFooterTitle = footerMainEle.querySelector('.sticky_title') as HTMLElement;
    const footerFooterIcon = footerMainEle.querySelector('.icon.sticky_icon') as HTMLElement;
    const footerMain = document.querySelector('footer') as HTMLElement;
    
    // Make footer always fixed at bottom
    footerMainEle?.classList?.remove('hidden');
    footerMainEle?.classList?.add('footer-fixed');
    
    // Adjust footer padding to prevent content overlap
    if (footerMain) {
        footerMain.style.paddingBottom = footerMainEle.offsetHeight + "px";
    }
    if (brandData.sticky_subtitle && footerFooterTitle) {
        footerFooterTitle.innerHTML = brandData.sticky_subtitle;

        if (brandData?.sticky_subtitle_icon?.trim() && footerFooterIcon) {
            footerFooterIcon.innerHTML = brandData.sticky_subtitle_icon;
        }
    }
    if (brandData?.sticky_icon?.trim() && footerFooterIcon) {
        footerFooterIcon.innerHTML = brandData.sticky_icon;
    }
    if(!footerFooterTitle && brandData.sticky_title){
        const anchorTag = document.querySelector(".sticky-footer .sticky-footer-cta")as HTMLElement;
        if(!anchorTag) return;
        const anchorTagText = anchorTag.outerHTML;
        const replacedText = `${anchorTagText.split("</svg>")[0]}</svg>${brandData.sticky_title}</a>`;
        const footerWrap = document.querySelector(".sticky-footer-wrap") as HTMLElement;
        if(footerWrap)
            footerWrap.innerHTML = replacedText;
        else
        //fallback scenario
        if(anchorTag.parentElement){
            anchorTag.parentElement.innerHTML = replacedText;
        }
    }
    
}

// Add class on gallery popup modal when card footer not availabel
document.querySelectorAll('.gallery-modal .modal-content .pop-up-img-slider').forEach(li => {
    if (!li.querySelector('.card-footer')) {
        li?.classList.add('no-footer'); // Adds class to li if it doesn't contain a div
    }
});


document.addEventListener('DOMContentLoaded', async function () {

    const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
    const brandData = await getBrandDetailsFromBrandJson(conceptCode);

    const hideDBANameAndPhoneMobile = (hideAttr: string) => {
        const phoneElement = document.querySelectorAll(`.${hideAttr}`);
        phoneElement?.forEach((element) => {
            if (element && brandData?.[hideAttr]) {
                element.classList.add('hidden');
                (element as HTMLElement).style.display = 'none';
            } else {
                if (hideAttr !== 'disable_phone_cta_os_flow') {
                    (element as HTMLElement).style.display = 'block';
                }
                element?.classList.remove('hidden');
            }
        });
    }


    hideDBANameAndPhoneMobile(`disable_phone_os_flow`);
    hideDBANameAndPhoneMobile(`disable_dba_os_flow`);
    const screenType = reportScreenSize();
    if (screenType !== ScreenType.Desktop) {
        hideDBANameAndPhoneMobile(`disable_phone_cta_os_flow`); // for mobile devices
    }
})

    export function registerClickToCallAnalytics(): void {
        const clickToCallLinks = document.querySelectorAll<HTMLAnchorElement>('a.click-to-call[href]');
        clickToCallLinks.forEach((link) => {
            link.addEventListener('click', () => {
            const dataLayer = (globalThis as any).dataLayer;
            if (typeof dataLayer?.push !== 'function') return;

            dataLayer.push({
                event: 'ComponentClick2call',
                PageType: 'HomePage',
                Localization: isLocalized() ? 'Local' : 'National',
                ComponentName: 'ImageTileSix',
                PageUrl: window.location.href,
                Phone: link.getAttribute('href'),
                ...getSureStartProgramData(),
            });
            });
        });
    }

    //US-460495: Add new CTA for 50-50 media tiles component Start
    function clickToCallHandler(){
    // Select all elements with the class 'card-main clicktocall'
    const clickToCallDivs = document.querySelectorAll<HTMLDivElement>('.card-item .card-main.clicktocall');
    if (clickToCallDivs.length > 0) {
        clickToCallDivs.forEach((div) => {
            //For each clicktocall card add the dni number in href
            const mobileLink = div.querySelector<HTMLAnchorElement>('.mobile-only');
            const fullLink = div.querySelector<HTMLAnchorElement>('.full-link');
            if (mobileLink && fullLink) {
                const dniNumber = mobileLink.getAttribute('href');
                if(dniNumber){
                    fullLink.setAttribute('href', dniNumber);
                    fullLink.removeAttribute('target')
                }
            }
        });
    }
  }
  //US-460495: Add new CTA for 50-50 media tiles component End
  
   //-----------------Coupon 8----------------------------//
   function attachEventListnerForCoupon8() {
    attachEventListenerForClaim('.sp-offers-section.coupons-eight', 'a.secondary-btn','li.sp-offers-item',{
        titleSelector: '.sp-offers-details .sp-offer',
        descriptionSelector: '.sp-offers-details .sp-offer-desc',
        expirySelector: '.sp-offer-expire',
        disclaimerSelector: '.sp-offers-disclaimer',
        couponCodeInputSelector: '#coupons-code'
    }); 
}

 //-----------------Coupon 11----------------------------//

function attachEventListnerForCoupon11() {
    attachEventListenerForClaim('.offers-block-section', '.offers-block-item a.secondary-btn','li.offers-block-item',{
        titleSelector: '.offers-block-details .block-offer',
        descriptionSelector: '.offers-block-details .offers-block-desc',
        expirySelector: '.offers-block-main .offers-block-expire',
        disclaimerSelector: '.offers-block-disclaimer',
        couponCodeInputSelector: '#block-coupons-code'
    }); 
    
}

/********* Added NBLY header logo and CTA text for National & Localisation page *********/

function addNblyHeaderInformation() {
    const nblyMain = document.querySelector('.nbly-main') as HTMLElement;
    const nblyCta = nblyMain?.querySelector('.nbly-cta') as HTMLElement;
    if (!nblyMain) return;
    getMessagesData().then((data) => {
        const nblyHeaderBanner = data?.nblyHeaderBanner;
        if (nblyHeaderBanner) {
            handleNblyHeaderImage(nblyMain, nblyHeaderBanner);
            handleNblyHeaderCta(nblyCta, nblyHeaderBanner);
        }
    }).catch((err) => {
        console.log(err, "Error in getting the function addNblyHeaderInformation");
    });
}

function handleNblyHeaderImage(nblyMain: HTMLElement, nblyHeaderBanner: any) {
    const nblyImgLogo = nblyMain?.querySelector('.nbly-logo') as HTMLElement;
    const nblyImgLogoAnchorTag = nblyMain?.querySelector('.nbly-block a') as HTMLElement;

    const nblyLogo = nblyHeaderBanner?.logoImage;
    const nblyAltText = nblyHeaderBanner?.logoAltText;
    const nblyOpenNewTab = nblyHeaderBanner?.logoOpenNewTab?.toLocaleLowerCase();
    const nblyImageLink = nblyHeaderBanner?.imageLink;

    if (nblyOpenNewTab === 'yes' && nblyImgLogoAnchorTag) {
        nblyImgLogoAnchorTag.setAttribute('target', '_blank');
    }
    if (nblyImageLink && nblyImgLogoAnchorTag) {
        nblyImgLogoAnchorTag.setAttribute('href', nblyImageLink);
    }

    if (nblyImgLogo && nblyLogo) {
        nblyImgLogo.innerHTML = nblyLogo;
    }

    if (nblyAltText && nblyImgLogo) {
        nblyImgLogo.setAttribute('alt', nblyAltText);
    }
}

function handleNblyHeaderCta(nblyCta: HTMLElement | null, nblyHeaderBanner: any) {
    const nblyCtaText = nblyHeaderBanner?.nblyHeader_link;
    if (nblyCta && nblyCtaText?.length > 0) {
        nblyCta.innerHTML = '';
        nblyCtaText?.forEach((ctaText: any) => {
            const nblyCtaAnchorTag = document.createElement('a');
            const ctaAnchorText = ctaText.linkText;
            const ctaClass = ctaText.ctaClass;
            const ctaLinkType = ctaText.linkType;
            const ctaOpenNewTab = ctaText.openNewTab?.toLocaleLowerCase();

            if (ctaLinkType) {
                nblyCtaAnchorTag.setAttribute('href', ctaLinkType);
            }
            if (ctaClass) {
                nblyCtaAnchorTag.setAttribute('class', ctaClass);
            }
            if (ctaOpenNewTab === 'yes') {
                nblyCtaAnchorTag.setAttribute('target', '_blank');
            }
            if (ctaAnchorText) {
                nblyCtaAnchorTag.innerHTML = ctaAnchorText;
            }

            nblyCta.appendChild(nblyCtaAnchorTag);
        });
    }
}

/** End NBLY Header */


/*************** Start Service Large Media Tile Component ********************/
    function truncateTextWithEllipsis(section: HTMLElement) {
        const container = section.querySelector('.service-tile-list');
        if (container?.classList.contains('auto-expand-tile')) {
            return;
        }

        const paragraphs = section.querySelectorAll(".service-tile-card-subtext");
    
        if (paragraphs?.length > 0) {
            paragraphs.forEach(paragraph => {
                if (paragraph?.textContent) {  // Ensure paragraph and textContent are not null
                    const fullText = paragraph.textContent.trim();
                    const shortText = fullText.slice(0, 140);
    
                    // Only create ellipsis if fullText is longer than 140 characters
                    if (fullText.length > 140) {
                        const ellipsis = document.createElement("span");
                        ellipsis.textContent = "...";
                        ellipsis.classList.add("ellipsis");
                        ellipsis.style.cursor = "pointer";
                        ellipsis.setAttribute('data-fulltext', fullText);

                        // Ensure we modify paragraph text content safely
                        paragraph.textContent = shortText;
                        paragraph.appendChild(ellipsis);
                    }
                }
            });

            container?.addEventListener("click", (event) => {
                // Check if the clicked element is an ellipsis
                const target = event.target as HTMLElement;
                if (target?.classList.contains("ellipsis")) {
                    const paragraph = (event?.target as HTMLElement)?.parentElement; 
                    if (paragraph?.textContent) {
                        const fullText = (event.target as HTMLElement)?.getAttribute('data-fulltext');
                        if(fullText){
                            paragraph.textContent = fullText;
                        }
                    }
                }
            });
        }
    }

export function applyTruncateIfAutoExpandDisabled(): void {
    // Get all sections that might contain service tiles
    const sections = document.querySelectorAll('.service-tile-section, .replacement-block, .dynamic-service-5050-media-tile-component');

    if (sections.length > 0) {
        // Process each section individually
        sections.forEach((section) => {
            if (section instanceof HTMLElement) {
                truncateTextWithEllipsis(section);
            }
        });
    }
}
    
/*************** End Service Large Media Tile Component ********************/

/*************** NEW DYNAMIC MENU STARTS HERE *****************************/

export function dynamicMenuV4(dynamicMenuType: any) {
    
    const jsonDynamicMenu = dynamicMenuType ?? {};

    if(jsonDynamicMenu?.dynamicMenuType?.toLowerCase()?.trim() ==='dynamic menu icons'){
        document.querySelectorAll('.new-expand-menu.no-tab-switch').forEach((menuItem) => {
            menuItem.addEventListener('click', function (this: HTMLElement, event: Event) {
                event.preventDefault();

                const closestTabSibling = (menuItem as HTMLElement).closest(".tab-sibling");
                if (closestTabSibling) {
                    closestTabSibling.classList.add('hide-menu');
                }

                const targetMenuId = this.getAttribute('data-target');
                const targetMenu = targetMenuId ? document.getElementById(targetMenuId) : null;
                // const dynamicMenuWrap = document.querySelector('.dynamic-menu-wrap');
                const dynamicMenuWrap = targetMenu?.parentElement?.parentElement;

                if (dynamicMenuWrap?.classList.contains('dynamic-menu-wrap')) {
                    dynamicMenuWrap.classList.remove('hide-menu');
                    dynamicMenuWrap.classList.add('show-menu');
                }

                if (targetMenu) {
                    document.querySelectorAll('.new-submenu-inner-warp > div').forEach((subMenu) => {
                        subMenu.classList.add('hide-menu');
                        subMenu.classList.remove('show-menu');
                    });

                    document.querySelectorAll('.new-submenu-inner-wrap-mobile > div').forEach((subMenu) => {
                        subMenu.classList.add('hide-menu');
                        subMenu.classList.remove('show-menu');
                    });

                    targetMenu.classList.remove('hide-menu');
                    targetMenu.classList.add('show-menu');
                }
            });

            // Main back button functionality
            const backToMenuBtn = document.querySelectorAll('.back-to-menu-btn');
            backToMenuBtn.forEach((back) => {
                back.addEventListener('click', function handleClick(this: HTMLElement) {
                    const nameBack = this.getAttribute('data-back');
                    if (nameBack) {
                        const idWrap = document.getElementById(nameBack);
                        if (idWrap) {
                            idWrap.classList.remove('show-menu');
                            idWrap.classList.add('hide-Submenu');

                            const dynamicMenuWrap = idWrap?.closest('.dynamic-menu-wrap');
                            if (dynamicMenuWrap) {
                                dynamicMenuWrap.classList.add('hide-menu');
                                dynamicMenuWrap.classList.remove('show-menu');
                            }
                        }
                    }
                });
            });

            // Back button functionality
            const newBackBtn = document.querySelectorAll('.new-back-btn');
            newBackBtn.forEach((back) => {
                back.addEventListener('click', function handleClick(this: HTMLElement) {
                    const closestMegaMenu = (back as HTMLElement).closest(".mega-menu");
                    if (closestMegaMenu) {
                        const tabSibling = closestMegaMenu.querySelector(".tab-sibling");
                        if (tabSibling) {
                            tabSibling.classList.remove('hide-menu');
                        }
                    }

                    const nameBack = this.getAttribute('data-back');
                    if (nameBack) {
                        const idWrap = document.getElementById(nameBack);
                        if (idWrap) {
                            idWrap.classList.remove('show-menu');
                            idWrap.classList.add('hide-menu');
                        }
                    }
                });
            });

            // Reset submenu on mouse leave
            const dynamicMenuWraps = document.querySelectorAll('.dynamic-menu-wrap');
            const newSubMegaMenus = document.querySelectorAll('.new-submenu-inner-warp > div');

            if (dynamicMenuWraps && window?.matchMedia("(min-width: 1024px)").matches) {
                dynamicMenuWraps.forEach(dynamicMenuWrap => {
                    dynamicMenuWrap.addEventListener('mouseleave', function () {
                        newSubMegaMenus.forEach((menu) => {
                            menu.classList.remove('show-menu');
                            menu.classList.add('hide-menu');
                        });

                        dynamicMenuWrap.classList.add('hide-menu');
                        dynamicMenuWrap.classList.remove('show-menu');

                        const mainMenu = document.querySelectorAll(".new-dynamic-menu .mega-inner-warp");
                        mainMenu?.forEach((menu) => {
                            menu.classList.remove('hide-menu');
                        });
                    });
                });
            }
        });
    }
}
/******************  NEW DYNAMIC MENU ENDS HERE ********************************/

/******************  NEW DYNAMIC MENU LARGE MEDIA TILE ************************/

function localDynamicMenuLargeMediaTile() {
    try {

        const serviceLargeMediaTile = (document.getElementById('servicelargemediatile') as HTMLInputElement)?.value;
        const franchiseWebLocationId = (document.getElementById('weblocationId') as HTMLInputElement)?.value ?? localStorage.getItem('franchiseWebLocationId');
        const dbaName = localStorage.getItem('dbaName');

        if (serviceLargeMediaTile && franchiseWebLocationId && dbaName) {
            const jsonData = JSON.parse(serviceLargeMediaTile);       
            const jsonString = JSON.stringify(jsonData);
            
            const serviceLargeMediaTileApi = `${window.location.origin}/dynamicservicelargemediatiledata/${franchiseWebLocationId}/${dbaName}`;
            
            const request = {
                method: 'POST',
                url: serviceLargeMediaTileApi,
                data: { configJson: jsonString },
            };

            apiRequest(request).then((response: any) => {
                if (response) {
                    const serviceTileSection = document.querySelector('.service-tile-section');
                    if (serviceTileSection) {
                        serviceTileSection.outerHTML = response;                
                    }
                }
            }).catch((error) => {
                console.error('Error in fetching dynamic service large media tile data:', error);
            })
            .finally( async() => {
                //to fetch the token and replace
                await fetchLocalTokenInfo();
                const serviceTileSection = document.querySelector('.service-tile-section');
                if (serviceTileSection instanceof HTMLElement) {
                    truncateTextWithEllipsis(serviceTileSection);
                }
            });
        }
    } catch (error) {
        console.error('An error occurred in localDynamicMenuLargeMediaTile function:', error);
    }
}

/******************  END NEW DYNAMIC MENU LARGE MEDIA TILE ********************/

//Start of logic to handle Dynamic Menu Service Accordion Localised Header National Site //
export function dynamicMenuServiceAccordion() {
    try {
        const dynamicServiceAccordion = (document.getElementById('dynamicserviceaccordion') as HTMLInputElement)?.value;
        const webId: string | null = localStorage.getItem('weblocationId');
        const dbaName = localStorage.getItem('dbaName');
        let jsonData, jsonString;
        if (dynamicServiceAccordion && webId && dbaName && window.location.href.includes(dbaName)) {
            jsonData = JSON.parse(dynamicServiceAccordion);
            jsonString = JSON.stringify(jsonData);
            sessionStorage.setItem('dynamicAccorInfo', jsonString);
        }
        if (dynamicServiceAccordion && webId && dbaName && !window.location.href.includes(dbaName)) {
            const jsonStringAccor = sessionStorage.getItem('dynamicAccorInfo');
            const serviceAccordionApi = `${window.location.origin}/dynamicserviceaccordiondata/${webId}/${dbaName}`;

            const request = {
                method: 'POST',
                url: serviceAccordionApi,
                data: { configJson: jsonStringAccor },
            };

            apiRequest(request).then((response: any) => {
                if (!response) {
                    return;
                }

                const serviceTileSection = document.querySelector('.residential-block.dynamic-service-accordion');
                if (!serviceTileSection) { return };

                serviceTileSection.outerHTML = response;
                readMoreButton();
                // ReInitialize the accordion click functionality
                const serviceTileAccor = document.querySelector("#dynamic-accordion-service");
                if (!serviceTileAccor) { return };
                serviceTileAccor?.querySelectorAll("[data-accordion-target]").forEach((btn: any) => {
                    btn.addEventListener("click", () => {
                        const targetId = btn.getAttribute("data-accordion-target");
                        if (!targetId) return;
                        const targetElement = document.querySelector(targetId);
                        if (!targetElement) return;
                        const isExpanded = btn.getAttribute("aria-expanded") === "true";

                        document.querySelectorAll<HTMLButtonElement>(".list-accordion-btn").forEach(btn => {
                            btn.setAttribute("aria-expanded", "false");
                        });

                        // Toggle the clicked accordion
                        if (targetElement) {
                            targetElement.classList.toggle("hidden", isExpanded);
                            btn.setAttribute("aria-expanded", String(!isExpanded));
                        }
                    });
                });

            }).catch((error) => {
                console.error('Error in fetching dynamic service accordion data:', error);
            });
        }
    } catch (error) {
        console.error('An error occurred in dynamic service accordion function:', error);
    }
}

//End//

//Start dynamic menu scroll//
export function dynamicScroll() {
    //  Stop default browser behavior from jumping to hash
    if (window.location.hash) {
        history.scrollRestoration = "manual"; // prevents browser auto-scroll
        document.documentElement.style.scrollBehavior = "auto"; // Temporarily disable smooth scrolling
        window.scrollTo(0, 0); // Force reset to top
    }
 
    //  Handle smooth scrolling after page completely loads
    window.addEventListener("DOMContentLoaded", () => {
        if (window.location.hash) {
            requestAnimationFrame(scrollToHash);
        }
    });

    // Handling smooth scroll when browser url is selected and enter key is pressed
    window.addEventListener("popstate", () => {
        if (window.location.hash) {
        requestAnimationFrame(scrollToHash);
        }
    });
 
    //  Function to smoothly scroll to the target element
    const scrollToHash = (): void => {
        const hash = window.location.hash;
        if (!hash || /\/.*/.test(hash)) return;
        const targetElement = document.querySelector(decodeURIComponent(hash));
        if (!targetElement) return;
 
        // Function to get header height
        const getHeaderHeight = (): number => {
            const header = document.querySelector(".second-head") as HTMLElement;
            return header ? header.offsetHeight : 0;
        };
 
        // Ensure the header is fully loaded before scrolling
        const waitForHeader = (callback: () => void) => {
            const checkHeader = () => {
                const header = document.querySelector(".second-head");
                if ((header as HTMLElement) && (header as HTMLElement)?.offsetHeight > 0) {
                    callback();
                } else {
                    requestAnimationFrame(checkHeader);
                }
            };
            checkHeader();
        };
 
        waitForHeader(() => {
            const headerHeight = getHeaderHeight();
            const targetPosition = (targetElement as HTMLElement).offsetTop;
            requestAnimationFrame(() => {
                document.documentElement.style.scrollBehavior = "smooth";
                window.scrollTo({
                    top: targetPosition - headerHeight - 10,
                    behavior: "smooth"
                });
            });
        });
    }
}

/******************  START NEW DYNAMIC MENU LARGE 25/75 MEDIA TILE 25/75 ************************/
export function localDynamicMenuLarge2575MediaTile() {
    try {
        const serviceLargeMediaTile = (document.getElementById('replacementblockdynamic') as HTMLInputElement)?.value;
        const franchiseWebLocationId = (document.getElementById('weblocationId') as HTMLInputElement)?.value ?? localStorage.getItem('franchiseWebLocationId');
        const dbaName = localStorage.getItem('dbaName');
        if (serviceLargeMediaTile && franchiseWebLocationId && dbaName) {
             // Direct JSON.parse to preserve SVG icon markup
            let decodedValueTile: any = null;
            try {
                decodedValueTile = JSON.parse(serviceLargeMediaTile);
            } catch {
                const text = serviceLargeMediaTile.replace(/&quot;/g, '"').replace(/&#39;/g, "'");
                try {
                    decodedValueTile = JSON.parse(text);
                } catch (err) {
                    console.warn("Failed to parse serviceLargeMediaTile JSON", err);
                    return;
                }
            }
            if (!decodedValueTile || typeof decodedValueTile !== 'object') {
                console.warn("Invalid serviceLargeMediaTile data");
                return;
            }
            
            const jsonString = JSON.stringify(decodedValueTile);
            
            const serviceLargeMediaTileApi = `${window.location.origin}/dynamicservicemediatextlistdata/${franchiseWebLocationId}/${dbaName}`;
            
            const request = {
                method: 'POST',
                url: serviceLargeMediaTileApi,
                data: { configJson: jsonString },
            };
            apiRequest(request).then((response: any) => {
                if (response) {
                    const serviceTileSection = document.querySelector('.replacement-block');
                    if (serviceTileSection) {
                        serviceTileSection.outerHTML = response;
                    }
                }
            }).catch((error) => {
                console.warn('Error in fetching dynamic service large media tile data:', error);
            }).finally(async () => {
                //to fetch the token and replace
                await fetchLocalTokenInfo();
                const replacementBlock = document.querySelector('.replacement-block');
                if (replacementBlock instanceof HTMLElement) {
                    truncateTextWithEllipsis(replacementBlock);
                }

            });
        } 
    } catch (error) {
        console.warn('An error occurred in localDynamicMenuLarge2575MediaTile function:', error);
    }
}
/******************  END NEW DYNAMIC MENU LARGE 25/75 MEDIA TILE 25/75 ********************/

/***************** WHY CHOOSE US SECTION MORE TEXT JS STARTS HERE *************************/
document.addEventListener("DOMContentLoaded", () => {
    const maxChars: number = 160;
    const subtexts: NodeListOf<HTMLElement> = document.querySelectorAll(".more-text");

    if (!subtexts.length) return;

    subtexts.forEach((subtext) => {
        const fullText: string | undefined = subtext.textContent?.trim();
        if (!fullText || fullText.length <= maxChars) return;

        subtext.innerHTML = `${fullText.substring(0, maxChars)}... <span style="color:blue;cursor:pointer" class="toggle">Read More</span>`;

        const toggleButton = subtext.querySelector<HTMLElement>(".toggle");
        toggleButton?.addEventListener("click", () => {
            subtext.textContent = fullText;
        });
    });
});

/***************** WHY CHOOSE US SECTION MORE TEXT JS END HERE *************************/

/**************** START SMOOTH SCROLLING *********************/

document.addEventListener("DOMContentLoaded", () => {
    const hash = window.location.hash;
    if (hash && !/\/.*/.test(hash)) {
      const targetElement = document.querySelector(hash);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
})
/**************** END SMOOTH SCROLLING *********************/

// Function to default expand ALL FAQs the accordion on page load for Desktop view

export function waitForFlowBite() {
    const delays = [0, 500, 1000, 5000]; // Initial attempt (0ms), then retries

    const attemptInit = (attempt = 0) => {
        if (attempt >= delays.length) {
            console.error("All attempts to initialize accordions failed.");
            return;
        }

        setTimeout(() => {
            try {
                safeInitAccordions();
            } catch (e) {
                console.warn(`Accordion init attempt ${attempt + 1} failed. Retrying...`,e);
                attemptInit(attempt + 1);
            }
        }, delays[attempt]);
    };

    attemptInit();
}
// Function to safely initialize accordions
export function safeInitAccordions() {
    const accordionTriggers = document.querySelectorAll('[data-accordion-target]');
    let allTargetsExist = true;
    
    for (const trigger of accordionTriggers) {
        const targetSelector = (trigger as HTMLElement).dataset.accordionTarget;
        try {
            if (!targetSelector || !document.querySelector(targetSelector)) {
                allTargetsExist = false;
            }
        } catch (e) {
            console.log("Error in selector:", e);
            allTargetsExist = false; // Invalid selector is treated as a missing target
        }
    }
    
    if (allTargetsExist && typeof window.initAccordions === 'function') {
        try {
            window.initAccordions();
        } catch (error) {
            console.error("Error during accordion initialization:", error);
            throw error; // Rethrow to signal a retry
        }
    } else {
        // Throw an error to signal a retry
        throw new Error("Accordion prerequisites not met.");
    }
}

export function expandAccordionOnLoad(faqSelector = '.faqs-section ul.accordion-icon-list.accordion-icon-list .list-accordion-btn') {
    try {
        const screenType = reportScreenSize();
        if (screenType == ScreenType.Desktop) {
            const ulSetOpenAttribute = document.querySelectorAll(".faqs-section ul.accordion-icon-list.accordion-icon-list")
            if (ulSetOpenAttribute && ulSetOpenAttribute.length > 0) {
                ulSetOpenAttribute.forEach((ul: any) => {
                    ul.setAttribute("data-accordion", "open");
                });
            }
        }
        const accordionList = document.querySelectorAll<HTMLUListElement>(".residential-accordion ul.accordion-icon-list")
        if (accordionList && accordionList.length > 0) {
            accordionList.forEach((ul) => {
                ul.setAttribute("data-accordion", "open");
            });
        }
        // Check if flowbite has loaded
        waitForFlowBite();
        
        if (screenType == ScreenType.Desktop) {
        const faqButtons = document.querySelectorAll(faqSelector);
        if (!faqButtons || faqButtons.length === 0) return;
        faqButtons.forEach(btn => {
            const targetId = btn.getAttribute("data-accordion-target");
            if (!targetId) return;
            const targetElement = document.querySelector(targetId);
            if (!targetElement) return;
            if (btn && typeof (btn as HTMLElement).click === "function") {
                const isExpanded = btn.getAttribute("aria-expanded") === "true";
                if (!isExpanded) {
                    targetElement.classList?.remove("hidden");
                    btn.setAttribute("aria-expanded", "true");
                    (btn as HTMLElement).click();
                }
            }
        });
        }
        void expandAccordionByBrandConfig();
    } catch (error) {
        console.error("Error in expandAccordionOnLoad:", error);
    }
}
/** 
 * Function to expand service accordion by default based on expand_service_accordion
 */
export async function expandAccordionByBrandConfig(){
    try{
        const conceptCodeElement = document.getElementById('conceptCode')
        if(!conceptCodeElement) return;
        const conceptCode = (conceptCodeElement as HTMLInputElement).value
        const brandDetails = await getBrandDetailsFromBrandJson(conceptCode) as Record<string, string> | null
        if(!brandDetails?.expand_service_accordion){
            const accordionList = document.querySelectorAll<HTMLUListElement>(".residential-accordion ul.accordion-icon-list")
            accordionList.forEach((ul) => {
                ul.setAttribute("data-accordion", "collapse");
            });
            return;
        }
        const buttonList = document.querySelectorAll<HTMLButtonElement>('.residential-accordion ul.accordion-icon-list button.list-accordion-btn')
        if(!buttonList.length) return;
        buttonList.forEach((btn) => {
            btn.click();
        })
    }catch(e){
        console.warn("Error in expandAccordionByBrandConfig:", e);
    }
}

// Enchance the Nav Dropdown for functionality
type NavElement = HTMLElement & {
    querySelectorAll<E extends Element = Element>(selectors: string): NodeListOf<E>;
};

const addHoverIntent = (nav: NavElement) => {
    const hoverables = nav.querySelectorAll<HTMLElement>('.headl2-hoverable');
    const opts = {
        sensitivity: 7,
        timeout: 100,
        interval: 50
    };

    hoverables.forEach((item) => {
        hoverintent(
            item,
            function () { item.classList.add('hovering'); },
            function () { item.classList.remove('hovering'); }
        ).options(opts);
    });
};

export function initializeNavDropdown() {
    // Add Eventlistener for Nav Dropdown
    const nav = document.querySelector('.main-nav-warpper');
    if (!nav) return;

    // Remove the hoverable effect from everything in the nav.
    Array.from(nav.querySelectorAll('.hoverable')).forEach((hoverable) => {
        hoverable.classList.remove('hoverable');
        hoverable.classList.add('headl2-hoverable');
    });
    addHoverIntent(nav as NavElement);
}
// Function to handle pricing component 7
export async function pricingComponent7() {
    try {
        const webLocationId = (document.getElementById('weblocationId') as HTMLInputElement)?.value ?? localStorage.getItem('franchiseWebLocationId');
        const conceptCode = (document.getElementById("conceptCode") as HTMLInputElement)?.value;
        const brandData = await getBrandDetailsFromBrandJson(conceptCode);
        const conceptId = (document.getElementById("conceptId") as HTMLInputElement)?.value ?? null;
        const vendorId = brandData?.vendorId;
        const serviceSkuId = (document.getElementById("media_with_form_dynamic_pricing_serviceid") as HTMLInputElement)?.value ?? null;
        if (webLocationId && vendorId && conceptId && serviceSkuId) {
            startLoader();
            const response = await cachedAPIWrapper(`${apiConfig.QUOTE_API_URL}?webLocationId=${webLocationId}&vendorId=${vendorId}&conceptId=${conceptId}&serviceSkus=${serviceSkuId}`);
            if (response?.services?.length > 0) {
                const service = response?.services?.find((s: any) => s.serviceID == serviceSkuId); // ServiceID 2: Dumpster Rental
                const ul = document.querySelector(".media_with_form_dynamic_pricing");
                if (!ul) return;

                const allItems = ul.querySelectorAll(".check-list-item");
                if (allItems.length === 0) return;

                const templateLi = allItems[0] as HTMLLIElement;
                const checkListText = templateLi?.querySelector(".check-list-text");
                if (checkListText) {
                    (checkListText as HTMLElement).innerText = "";
                }else{
                    templateLi.innerText = "";
                }

                // Remove all other LIs
                allItems.forEach((li, idx) => {
                    if (idx !== 0) li.remove();
                });

                // Clone template and append for each price
                service?.pricingTiers?.forEach((tier: { label: string; price: number }, index: number) => {
                    const newLi = templateLi.cloneNode(true) as HTMLLIElement;
                     const textNode = newLi?.querySelector(".check-list-text");
                    if (textNode) {
                        textNode.textContent = `${tier?.label} - $${tier?.price}`;
                    } else {
                        // fallback if <p> doesn't exist (shouldn't normally happen)
                        newLi.textContent = `${tier?.label} - $${tier?.price}`;
                    }
                    // Append only cloned items; skip first
                    if (index === 0) {
                        const checkListText = templateLi?.querySelector(".check-list-text");
                        if (checkListText) {
                            (checkListText as HTMLElement).innerHTML = textNode?.textContent ?? "";
                        }else{
                            templateLi.textContent = newLi.innerText; 
                        }
                    } else {
                        ul.appendChild(newLi);
                    }
                });
            }else{
                showPricingErrorMsg();
            }
            stopLoader();
        }
    } catch (error) {
        console.error("Error in pricingComponent7:", error);
        stopLoader();
        showPricingErrorMsg();
    }
}

function showPricingErrorMsg() {
    const ul = document.querySelector(".media_with_form_dynamic_pricing");
    const errorMsg = document.querySelector(".dynamic-list-err-msg");
    if (errorMsg) {
        errorMsg.classList.remove("hidden");
        ul?.classList.add("hidden");
    }
}

/**
 * Dynamic Pricing Section
 *
 * Updates `.pricing-amount-value` elements inside a `.pricing-section` that has
 * been opted into dynamic pricing via the `dynamic-pricing-section` marker class,
 * and shows only the pricing comparison `.pricing-card` elements that have valid
 * pricing data — hiding the rest, or the whole section when nothing is valid.
 *
 * The function is a no-op unless the marker class is present, so existing static
 * `.pricing-section` markup from Crownpeak continues to render as-is.
 *
 * Flow:
 * 1. Detect `.pricing-section.dynamic-pricing-section` on the page.
 * 2. Only continue when the header is localized — this covers both page types:
 *    Local page templates are always localized already, while National page
 *    templates are only evaluated once the visitor has localized the header.
 *    Otherwise hide the section.
 * 3. Resolve the franchise web location id (hidden input or localStorage).
 * 4. Fetch `franchiseWebLocationProfileFees` for that location. If pricing
 *    data isn't available, hide the section.
 * 5. For each `.pricing-card`, match its `#pricing_card_identifier` hidden
 *    input value against a fee's `name` in the API response (substring match)
 *    and replace the text of the `.pricing-amount-value` span with the
 *    `defaultFee` rounded to the nearest whole dollar plus a trailing `*`
 *    (e.g. `113.49` -> `$113*`, `113.50` -> `$114*`). The authored markup
 *    keeps a default fee in that span hidden via `visibility: hidden` (to
 *    reserve space and avoid layout shift); once the real value is set, that
 *    `visibility` style is removed so it becomes visible.
 * 6. For the same card, match its `#pricing_card_alternate_identifier` hidden
 *    input value against a fee's `name` in the API response the same way, and
 *    replace the `{fee}` placeholder in `.pricing-alternate-text.dynamic` with
 *    the matched `defaultFee` rounded to the nearest whole dollar (e.g.
 *    `113.49` -> `$113`, `113.50` -> `$114`) plus a trailing `*` referencing
 *    the pricing disclaimer footnote. If no alternate fee matches, the
 *    authored placeholder text (including the literal `{fee}`) is left as-is.
 * 7. Keep only the cards that matched a valid comparison key visible (hide
 *    the rest). If none matched, hide the entire section.
 */
export async function dynamicPricingSection() {
    const pricingSection = document.querySelector(".pricing-section.dynamic-pricing-section") as HTMLElement | null;
    if (!pricingSection) return;

    try {
        // Only run on localized pages — the profile fees API requires a
        // franchise web location id that is only available after localization.
        if (!isLocalized()) {
            pricingSection.classList.add("hidden");
            return;
        }

        const webLocationId = (document.getElementById('weblocationId') as HTMLInputElement)?.value
            ?? localStorage.getItem('weblocationId')
            ?? localStorage.getItem('franchiseWebLocationId');
        if (!webLocationId) {
            console.warn("dynamicPricingSection: missing franchiseWebLocationId, skipping.");
            pricingSection.classList.add("hidden");
            return;
        }

        const url = `${apiConfig.franchiseWebLocationProfileFees}/${webLocationId}`;
        const response = await cachedAPIWrapper(url, apiCaching.FranchiseWebLocationProfileFees, false);
        if (!Array.isArray(response) || response.length === 0) {
            console.warn("dynamicPricingSection: no profile fees returned from API.");
            pricingSection.classList.add("hidden");
            return;
        }

        const pricingCards = pricingSection!.querySelectorAll(".pricing-card");
        if (pricingCards.length === 0) {
            console.warn("dynamicPricingSection: no .pricing-card elements found.");
            pricingSection.classList.add("hidden");
            return;
        }

        // Match each card to a fee via its hidden input value.
        // The input (e.g. <input type="hidden" id="pricing_card_identifier" value="Up to 1500 sq ft, weekly">)
        // is matched against the fee name from the API response using
        // substring inclusion so card order in the DOM doesn't matter.
        // Cards that don't match a valid key are hidden; if none match, the
        // whole section is hidden.
        let matchedCardCount = 0;
        pricingCards.forEach((card: Element) => {
            const identifierInput = card.querySelector("#pricing_card_identifier") as HTMLInputElement | null;
            const identifierValue = identifierInput?.value?.trim();

            const fee = identifierValue
                ? response.find((f: any) => (f?.name ?? "").includes(identifierValue))
                : undefined;

            if (!fee) {
                card.classList.add("hidden");
                return;
            }

            matchedCardCount++;
            card.classList.remove("hidden");

            const amountValueEl = card.querySelector(".pricing-amount-value") as HTMLElement | null;
            if (amountValueEl) {
                const formattedFee = formatProfileFee(fee?.defaultFee);
                if (formattedFee) {
                    amountValueEl.textContent = formattedFee;
                }
                // The authored markup keeps a default fee hidden via
                // `visibility: hidden` to reserve space and avoid layout shift.
                // Reveal it now that the card is confirmed as a match — even
                // if the API's defaultFee was invalid, in which case the
                // authored placeholder value is left in place as a fallback.
                amountValueEl.style.removeProperty("visibility");
            }

            // Alternate pricing text (e.g. the bi-weekly rate shown under the
            // primary weekly rate). Matched the same way as the primary fee,
            // via #pricing_card_alternate_identifier, and injected into the
            // "{fee}" placeholder of .pricing-alternate-text.dynamic.
            const alternateIdentifierInput = card.querySelector("#pricing_card_alternate_identifier") as HTMLInputElement | null;
            const alternateIdentifierValue = alternateIdentifierInput?.value?.trim();
            const alternateFee = alternateIdentifierValue
                ? response.find((f: any) => (f?.name ?? "").includes(alternateIdentifierValue))
                : undefined;

            const alternateTextEl = card.querySelector(".pricing-alternate-text.dynamic") as HTMLElement | null;
            if (alternateTextEl && alternateFee) {
                const formattedAlternateFee = formatProfileFee(alternateFee?.defaultFee);
                if (formattedAlternateFee && alternateTextEl.textContent?.includes("{fee}")) {
                    alternateTextEl.textContent = alternateTextEl.textContent.replace("{fee}", formattedAlternateFee);
                }
            }
        });

        if (matchedCardCount === 0) {
            pricingSection.classList.add("hidden");
        }
    } catch (error) {
        console.error("Error in dynamicPricingSection:", error);
        pricingSection?.classList.add("hidden");
    }
}

/**
 * Formats a numeric fee from the franchiseWebLocationProfileFees API into a
 * rounded whole-dollar display string, with a trailing `*` referencing the
 * pricing disclaimer footnote (e.g. `113.49` -> `$113*`, `113.50` -> `$114*`).
 * Used for both the primary `.pricing-amount-value` price and the alternate
 * pricing text's `{fee}` placeholder. Returns null for invalid, zero, or
 * negative values so the caller can leave the authored placeholder in place.
 */
function formatProfileFee(fee: any): string | null {
    const numericFee = typeof fee === "number" ? fee : Number(fee);
    if (!Number.isFinite(numericFee) || numericFee <= 0) return null;
    return `$${Math.round(numericFee)}*`;
}

export function handleMobileDesktopSubmenuClicks() {
    try {
        const screenType = reportScreenSize();
        const selector = screenType === ScreenType.Desktop ? '.new-submenu-list-main' : '.new-submenu-mobile-list-main';
        const menuList = document.querySelectorAll(selector);
        if (!menuList) return;

        menuList.forEach((menu) => {
            menu.addEventListener("click", (event) => {
                const target = event.target as HTMLElement;
                // Find the anchor element
                const link = target.closest("a.new-submenu-list-link") as HTMLAnchorElement;
                if (!link) return;

                const href = link.getAttribute("href") ?? "";
                const isHashLink = href.includes("#");
                const hash = href.split("#")[1];

                if (isHashLink && hash?.length > 1 && target) {
                    if (screenType === ScreenType.Desktop) {
                        const hoveringElement = target.closest(".hovering") as HTMLElement;
                        if (hoveringElement) {
                            hoveringElement.classList.remove("hovering");
                            const dynamicMenuWraps = document.querySelectorAll('.dynamic-menu-wrap');
                            dynamicMenuWraps.forEach(dynamicMenuWrap => {
                                dynamicMenuWrap.classList.add('hide-menu');
                                dynamicMenuWrap.classList.remove('show-menu');
                            });
                            
                            // Reset all submenus
                            const mainMenu = document.querySelectorAll(".new-dynamic-menu .mega-inner-warp");
                            mainMenu?.forEach((menu) => {
                                menu.classList.remove('hide-menu');
                            });
                        }
                    } else {
                        const closeBtn = document.querySelector('[data-drawer-hide="sidebar"]') as HTMLButtonElement;
                        if (closeBtn) {
                            closeBtn.click(); // Let your framework handle transitions/ARIA
                        }
                    }
                }
            });
        });
    } catch (error) {
        console.error("Error handling mobile/desktop submenu clicks:", error);
    }
}

export function formatName(fullName: string | null | undefined): string {
        try {
            if (!fullName || typeof fullName !== 'string') return "";

        // Trim extra spaces and split
        const parts = fullName.trim().split(/\s+/);

        // If only one name exists, return as is
        if (parts.length === 1) return parts[0];

        const firstName = parts[0];
        const initials = parts.slice(1).map(name => name[0] + ".").join(" ");
        // If initials are empty, return just the first name
        return initials ? `${firstName} ${initials}` : firstName;

    } catch (error) {
        console.error("Error formatting name:", error);
        return "";
    }

}

export function handleNameFormatting(): void {
  try {
      const nameElements = document.querySelectorAll('.reviews-list .reviewer-name');
    if (!nameElements || nameElements.length === 0) return;

  nameElements?.forEach((element) => {
    if (!(element instanceof HTMLElement)) return;
    const fullName = element.textContent;

    // Skip if text content is null, empty, or just whitespace
    if (!fullName?.trim()) return;

    const formattedName = formatName(fullName);
    // Optional: only update if formatting is different
    if (formattedName && formattedName !== fullName.trim()) {
      element.textContent = formattedName;
    }
  });
  } catch (error) {
    console.error("Error formatting names:", error);
  }

}

/******************  START NEW DYNAMIC MENU LARGE 50/50 MEDIA TILE 50/50 ************************/
export async function localDynamicMenuLarge5050MediaTile() {
    try {
        const serviceLargeMediaTile = (document.getElementById('service5050mediatile') as HTMLInputElement)?.value;
        const franchiseWebLocationId = (document.getElementById('weblocationId') as HTMLInputElement)?.value ?? localStorage.getItem('franchiseWebLocationId');
        const dbaName = localStorage.getItem('dbaName');
        if (serviceLargeMediaTile && franchiseWebLocationId && dbaName) {
            // Direct JSON.parse to preserve SVG icon markup
            let decodedValue: any = null;
            try {
                decodedValue = JSON.parse(serviceLargeMediaTile);
            } catch {
                const text = serviceLargeMediaTile.replace(/&quot;/g, '"').replace(/&#39;/g, "'");
                try {
                    decodedValue = JSON.parse(text);
                } catch (err) {
                    console.warn("Failed to parse serviceLargeMediaTile JSON", err);
                    return;
                }
            }
            const jsonString = JSON.stringify(decodedValue);
            const serviceLargeMediaTileApi = `${window.location.origin}/dynamicservice5050mediatiledata/${franchiseWebLocationId}/${dbaName}`;
            
            const request = {
                method: 'POST',
                url: serviceLargeMediaTileApi,
                data: { configJson: jsonString },
            };
            apiRequest(request).then((response: any) => {
                if (response) {
                    const serviceTileSection = document.querySelector('.dynamic-service-5050-media-tile-component');
                    if (serviceTileSection) {
                        // Replace markup
                        serviceTileSection.outerHTML = response;
                        // Hide the Findus Modal section in localised header National scenario
                        const serviceTileSection1 = document.querySelector('.dynamic-service-5050-media-tile-component');
                        serviceTileSection1?.querySelectorAll('.find-a-loc-wrapper')?.forEach(wrapper => {
                            if (wrapper) {
                                (wrapper as HTMLElement).style.display = 'none';
                            }
                        });
                    }
                }
            }).catch((error) => {
                console.warn('Error in fetching dynamic service large media tile 50/50 data:', error);
            }).finally(async () => {
                // To fetch the token and replace
                await fetchLocalTokenInfo();
                const dynamicServiceSection = document.querySelector('.dynamic-service-5050-media-tile-component');
                if (dynamicServiceSection instanceof HTMLElement) {
                    truncateTextWithEllipsis(dynamicServiceSection);
                }

            });
        } 
    } catch (error) {
        console.warn('An error occurred in localDynamicMenuLarge5050MediaTile function:', error);   
    }
}
/******************  END NEW DYNAMIC MENU LARGE 50/50 MEDIA TILE 50/50 ********************/

//Phone Number update in Real Time Communication Component if its used as Widget//

export async function updatePhoneNumberComponent() {
    const dbaName: string | null = localStorage.getItem('dbaName');
    const franchiseWebLocationId = (document.getElementById('weblocationId') as HTMLInputElement)?.value ?? localStorage.getItem('franchiseWebLocationId');
    const phoneLink = document.querySelector('.real-time-comm-cta.real-time-call-us') as HTMLAnchorElement;
    if (franchiseWebLocationId && dbaName && !globalThis.location.href.includes(dbaName) && phoneLink) {
        const str = getPageSettings('RealTimeCommunicationComponent');
        const pageScope = getPageSettings('pagescope');
        if ((str === 'true' || str === true) && pageScope === 'national') {
            const realTimeCommunicationApi = `${globalThis.location.origin}/realtimecta/${franchiseWebLocationId}/${dbaName}`;
            const request = {
                method: 'GET',
                url: realTimeCommunicationApi,
            };
            apiRequest(request).then((response: any) => {
                if (response) {
                    phoneLink.outerHTML = response;
                }
            }).catch((error) => {
                console.warn('Error in fetching Phone Number:', error);
            })
        }
    }
}
//End of Phone Number update in Real Time Communication Component if its used as Widget//
(async () => {
    await StickyHeader.init();
})();

window.addEventListener('pagehide', () => {
    StickyHeader.destroy();
});

/******************  Start Brand Popup HERE ********************************/

export function brandPopupHandler() {
    try {
        const brandPopupBtns = document.querySelectorAll('#brand-list .more-info');
        // Check if buttons exist add onclick event listener
        if (brandPopupBtns && brandPopupBtns.length > 0) {
            brandPopupBtns.forEach((btn) => {
                btn.addEventListener('click', async (event) => {
                    startLoader();
                    const brandData = (event.target as HTMLElement)?.closest('.right-btn') as HTMLElement;
                    console.log('brandData:', brandData);
                    const webLocationId = (brandData?.querySelector('.search-result-weblocationid')as HTMLInputElement)?.value ?? '';
                    const conceptId = (brandData?.querySelector('.search-result-conceptid')as HTMLInputElement)?.value ?? '';
                    const reviewRating = (brandData?.querySelector('.search-result-reviewrating')as HTMLInputElement)?.value || 0;
                    const reviewCount = (brandData?.querySelector('.search-result-reviewcount')as HTMLInputElement)?.value || 0;
                    const phoneNumber = (brandData?.querySelector('.search-result-phonenumber')as HTMLInputElement)?.value ?? '';

                   const locationUrl = (brandData?.querySelector('.search-result-locationurl') as HTMLInputElement)?.value ?? '';
                    
                    // Check if CA postal code to use /ca/brandmoreinfo endpoint
                    const storedZipCode = sessionStorage.getItem('brandZipCode') ?? '';
                    const isCA = isValidCAPostalCode(storedZipCode);
                    const brandPopupEndpoint = isCA ? '/ca/brandmoreinfo' : '/brandmoreinfo';
                    let brandPopupApi = `${window.location.origin}${brandPopupEndpoint}/${conceptId}/${webLocationId}/${reviewRating}/${reviewCount}/${phoneNumber}`;
                                      
                    if(locationUrl){
                        brandPopupApi += `/${locationUrl}`;
                    }

                    const request = {
                        method: 'GET',
                        url: brandPopupApi,
                    };
                    apiRequest(request).then((response: any) => {
                        if (response?.BrandMoreInfoPopupMarkup) {
                            const brandPopupContainer = document.querySelector('.brand-modal-body');
                            if (brandPopupContainer) {
                                brandPopupContainer.outerHTML = response.BrandMoreInfoPopupMarkup;
                                // Call the function to initialize the services toggle
                                initializeBrandPopupServicesToggle();
                                BrandPopupPhotoGallery?.getInstance()?.initSlider();
                                BrandPopupReviewSlider?.getInstance()?.initSlider();
                                BrandResult?.getInstance()?.constructAndAddUTMTagsToCTA();
                            }else{
                                console.error('Brand popup container not found.');
                            }
                        }
                        stopLoader();
                    }).catch((error) => {
                        stopLoader();
                        console.error('Error in fetching brand popup data:', error);
                    });
                });
            });
        }
    } catch (error) {
        console.error('An error occurred in brandPopupHandler function:', error);
    }
}
brandPopupHandler();


/***************** Sell all service List in Brandpopup Modal ****************/
export function initializeBrandPopupServicesToggle(): void {
    const modal = document.getElementById('brand-modal');
    if (!modal) return;

    const servicesSection = modal.querySelector('.brand-services-section');
    if (!servicesSection) return;

    const servicesList = servicesSection.querySelector('.services-list') ;
    if (!servicesList) return;

    const MAX_VISIBLE_SERVICES = 14; // Show first 14 services
    let allServices: string[] = [];
    let isExpanded = false;

    // Collect all service items
    function collectServices(): void {
        const items = servicesList?.querySelectorAll('li:not(.service-more-btn)');
        allServices = Array.from(items ?? []).map(item => item.textContent?.trim() || '');
    }

    // Render services in ul
    function renderServices(limit: number | null = null): void {
        const servicesToShow = limit ? allServices.slice(0, limit) : allServices;
        
        // Clear existing content
        if (servicesList) {
            servicesList.innerHTML = '';
        }
        
        // Add service items
        servicesToShow.forEach(service => {
            const li = document.createElement('li');
            li.textContent = service;
            if (servicesList) {
                servicesList.appendChild(li);
            }
        });
        
        // Add "...and many more!" if needed
        if (limit && allServices.length > limit) {
            const moreBtn = document.createElement('li');
            moreBtn.className = 'service-more-btn';
            moreBtn.textContent = '...and many more';
            if (servicesList) {
                servicesList.appendChild(moreBtn);
            }
        }
    }

    // Toggle between showing limited and all services
    function toggleServices(): void {
        isExpanded = !isExpanded;
        
        if (isExpanded) {
            renderServices(); // Show all
        } else {
            renderServices(MAX_VISIBLE_SERVICES); // Show limited
        }
    }

    // Initialize
    collectServices();
    
    // Only show "...and many more!" if there are more than MAX_VISIBLE_SERVICES
    if (allServices.length > MAX_VISIBLE_SERVICES) {
        renderServices(MAX_VISIBLE_SERVICES);
    } else {
        renderServices(); // Show all if less than or equal to MAX
    }
}
/******************  End Brand Popup HERE ********************************/
